import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  AnyAggridInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
};

/** Type description */
export type ActivityLog = {
  __typename?: 'ActivityLog';
  activity_detail?: Maybe<ActivityLogDetailObject>;
  activity_type?: Maybe<ActivityType>;
  created_by?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<ActivityLogDocumentType>;
  /** field description */
  id: Scalars['Int']['output'];
  reference_id?: Maybe<Scalars['Int']['output']>;
};

export type ActivityLogByRefereceIdInput = {
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogCopyObject = {
  __typename?: 'ActivityLogCopyObject';
  id?: Maybe<Scalars['Int']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogCopyObjectInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogCreateInput = {
  activity_detail: ActivityLogDetailObjectInput;
  activity_type: ActivityType;
  created_by: CreatorInputObject;
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogDetailObject = {
  __typename?: 'ActivityLogDetailObject';
  added_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  attachment_list?: Maybe<Array<Scalars['String']['output']>>;
  copied_from?: Maybe<ActivityLogCopyObject>;
  copied_to?: Maybe<ActivityLogCopyObject>;
  curr_status?: Maybe<Scalars['String']['output']>;
  deleted_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  message?: Maybe<Array<Scalars['String']['output']>>;
  prev_status?: Maybe<Scalars['String']['output']>;
  updated_fields?: Maybe<Scalars['Json']['output']>;
};

export type ActivityLogDetailObjectInput = {
  added_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  attachment_list?: InputMaybe<Array<Scalars['String']['input']>>;
  copied_from?: InputMaybe<ActivityLogCopyObjectInput>;
  copied_to?: InputMaybe<ActivityLogCopyObjectInput>;
  curr_status?: InputMaybe<Scalars['String']['input']>;
  deleted_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  prev_status?: InputMaybe<Scalars['String']['input']>;
  secondary_operation?: InputMaybe<ActivityType>;
  updated_fields?: InputMaybe<Scalars['Json']['input']>;
};

export enum ActivityLogDocumentType {
  BillingNote = 'billing_note',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  DepositInvoice = 'deposit_invoice',
  GoodsAdjustment = 'goods_adjustment',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer',
  Item = 'item',
  Maintenance = 'maintenance',
  Promotion = 'promotion',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Tire = 'tire',
  User = 'user',
  Vehicle = 'vehicle'
}

export type ActivityLogFindManyAggrid = {
  __typename?: 'ActivityLogFindManyAggrid';
  count: Scalars['Int']['output'];
  results: Array<ActivityLog>;
};

export type ActivityLogRelatedEmployeeObject = {
  __typename?: 'ActivityLogRelatedEmployeeObject';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogRelatedEmployeeObjectInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ActivityType {
  Active = 'active',
  AddRelatedEmployee = 'add_related_employee',
  Approve = 'approve',
  Cancel = 'cancel',
  CancelPendingScan = 'cancel_pending_scan',
  ChangePassword = 'change_password',
  Comment = 'comment',
  Copy = 'copy',
  Create = 'create',
  CreateImporter = 'create_importer',
  Delete = 'delete',
  DeleteRelatedEmployee = 'delete_related_employee',
  Document = 'document',
  Edit = 'edit',
  EditImporter = 'edit_importer',
  EditPermission = 'edit_permission',
  Image = 'image',
  InActive = 'in_active',
  SaveDatePayment = 'save_date_payment',
  StatusChange = 'status_change'
}

export enum AdditionalDiscountType {
  Baht = 'baht',
  Percent = 'percent'
}

export type AddressInputObject = {
  address_contact_fax?: InputMaybe<Scalars['String']['input']>;
  address_contact_name?: InputMaybe<Scalars['String']['input']>;
  address_contact_phone?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  is_same_as_default_address?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  sub_district?: InputMaybe<Scalars['String']['input']>;
};

export type AddressObject = {
  __typename?: 'AddressObject';
  address_contact_fax?: Maybe<Scalars['String']['output']>;
  address_contact_name?: Maybe<Scalars['String']['output']>;
  address_contact_phone?: Maybe<Scalars['String']['output']>;
  address_type?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_same_as_default_address?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  sub_district?: Maybe<Scalars['String']['output']>;
};

export enum AggridArrayFilterType {
  Array = 'array'
}

export type AggridBooleanFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridBooleanFilterModelType>;
};

export enum AggridBooleanFilterModelType {
  Equals = 'equals',
  NotEqual = 'notEqual'
}

export type AggridDateFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridDateFilterType>;
  type?: InputMaybe<AggridDateFilterModelType>;
};

export enum AggridDateFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridDateFilterType {
  Date = 'date'
}

export type AggridFloatFilterModelInput = {
  condition1?: InputMaybe<AggridFloatFilterModelInputCondition>;
  condition2?: InputMaybe<AggridFloatFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridFloatFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridGenericArrayFilterModelInput = {
  filterType?: InputMaybe<AggridArrayFilterType>;
  type?: InputMaybe<AggridGenericArrayFilterModelType>;
  values?: InputMaybe<Scalars['Any']['input']>;
};

export enum AggridGenericArrayFilterModelType {
  Equals = 'equals',
  Has = 'has',
  HasEvery = 'hasEvery',
  HasSome = 'hasSome',
  IsEmpty = 'isEmpty'
}

export enum AggridISimpleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export type AggridIntFilterModelInput = {
  condition1?: InputMaybe<AggridIntFilterModelInputCondition>;
  condition2?: InputMaybe<AggridIntFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridIntFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export enum AggridNumberFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridNumberFilterType {
  Number = 'number'
}

export enum AggridObjectArrayFilterModelType {
  Every = 'every',
  None = 'none',
  Some = 'some'
}

export enum AggridObjectArrayFilterType {
  ObjectArray = 'objectArray'
}

export enum AggridOperatorFilter {
  And = 'AND',
  Or = 'OR'
}

export type AggridSetSingleFilterModelInput = {
  condition1?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  condition2?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<AggridOperatorFilter>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export type AggridSetSingleFilterModelInputCondition = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridSetSingleFilterModelType>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export enum AggridSetSingleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual'
}

export type AggridSortModelItem = {
  colId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type AggridSortModelItemInput = {
  colId: Scalars['String']['input'];
  sort: SortOrder;
};

export type AggridStringFilterModelInput = {
  condition1?: InputMaybe<AggridStringFilterModelInputCondition>;
  condition2?: InputMaybe<AggridStringFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export type AggridStringFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export enum AggridStringFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export enum AggridStringModeOption {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type AggridTemplateInput = {
  endRow?: InputMaybe<Scalars['Int']['input']>;
  filterModel?: InputMaybe<Scalars['Any']['input']>;
  sortModel?: InputMaybe<Array<AggridSortModelItemInput>>;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};

export enum AggridTextFilterType {
  Text = 'text'
}

export type AttachmentInputObject = {
  attachment_name?: InputMaybe<Scalars['String']['input']>;
  uploaded_by?: InputMaybe<CreatorInputObject>;
  uploaded_date?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentObject = {
  __typename?: 'AttachmentObject';
  attachment_name?: Maybe<Scalars['String']['output']>;
  uploaded_by?: Maybe<CreatorObject>;
  uploaded_date?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BillingNote = {
  __typename?: 'BillingNote';
  accepted_date?: Maybe<Scalars['DateTime']['output']>;
  accepted_remark?: Maybe<Scalars['String']['output']>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  attachment_list: Array<AttachmentObject>;
  company_type?: Maybe<Scalars['String']['output']>;
  created_by: CreatorObject;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  customer_details: SalesCustomerObject;
  customer_unique_id: Scalars['String']['output'];
  delivery_trip_item_list?: Maybe<Array<DeliveryTripItemList>>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  due_date: Scalars['DateTime']['output'];
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date: Scalars['DateTime']['output'];
  item_list?: Maybe<Array<DeliveryTripList>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date: Scalars['DateTime']['output'];
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  related_user_list: Array<CreatorObject>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  vat_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_percent?: Maybe<Scalars['Float']['output']>;
};

export type BillingNoteByCustomerReportView = {
  __typename?: 'BillingNoteByCustomerReportView';
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  dt_document_amount?: Maybe<Scalars['Int']['output']>;
  income_net_amount?: Maybe<Scalars['Float']['output']>;
  income_pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_amount?: Maybe<Scalars['Float']['output']>;
};

export type BillingNoteByCustomerReportViewAggridOutput = {
  __typename?: 'BillingNoteByCustomerReportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<BillingNoteByCustomerReportView>;
};

export type BillingNoteByDeliveryItemReportView = {
  __typename?: 'BillingNoteByDeliveryItemReportView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  billing_address?: Maybe<Scalars['String']['output']>;
  company_type?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  credit_day?: Maybe<Scalars['Int']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_thb?: Maybe<Scalars['Float']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  dt_fuel_price?: Maybe<Scalars['Float']['output']>;
  dt_index: Scalars['Int']['output'];
  dt_issue_date?: Maybe<Scalars['DateTime']['output']>;
  dt_unique_id?: Maybe<Scalars['String']['output']>;
  dt_vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  dt_vehicle_type?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  income_item_name?: Maybe<Scalars['String']['output']>;
  income_item_pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  income_item_unique_id?: Maybe<Scalars['String']['output']>;
  income_unique_id: Scalars['String']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  job_no?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  related_user_list?: Maybe<Scalars['Json']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_percent?: Maybe<Scalars['Float']['output']>;
};

export type BillingNoteByDeliveryItemReportViewAggridOutput = {
  __typename?: 'BillingNoteByDeliveryItemReportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<BillingNoteByDeliveryItemReportView>;
};

export type BillingNoteByItemReportView = {
  __typename?: 'BillingNoteByItemReportView';
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
};

export type BillingNoteByItemReportViewAggridOutput = {
  __typename?: 'BillingNoteByItemReportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<BillingNoteByItemReportView>;
};

export type BillingNoteCreateInput = {
  accepted_date?: InputMaybe<Scalars['DateTime']['input']>;
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  attachment_list?: InputMaybe<Array<AttachmentInputObject>>;
  company_type?: InputMaybe<Scalars['String']['input']>;
  created_by: CreatorInputObject;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  customer_details: SalesCustomerInputObject;
  customer_unique_id: Scalars['String']['input'];
  delivery_trip_item_list?: InputMaybe<Array<DeliveryTripItemListCreateInput>>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discount_type?: InputMaybe<Scalars['String']['input']>;
  due_date: Scalars['DateTime']['input'];
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date: Scalars['DateTime']['input'];
  item_list?: InputMaybe<Array<DeliveryTripListCreateInput>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  related_user_list?: InputMaybe<Array<CreatorInputObject>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_percent?: InputMaybe<Scalars['Float']['input']>;
};

export type BillingNoteReportGenerateInput = {
  company_type?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  params?: InputMaybe<Scalars['Json']['input']>;
  report_type: BillingNoteReportType;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum BillingNoteReportType {
  BillingNote = 'billing_note',
  BillingNoteByCustomer = 'billing_note_by_customer',
  BillingNoteByDeliveryItem = 'billing_note_by_delivery_item',
  BillingNoteByItem = 'billing_note_by_item'
}

export type BillingNoteReportView = {
  __typename?: 'BillingNoteReportView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  billing_address?: Maybe<Scalars['String']['output']>;
  company_type?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  credit_day?: Maybe<Scalars['Int']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_thb?: Maybe<Scalars['Float']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  related_user_list?: Maybe<Scalars['Json']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_percent?: Maybe<Scalars['Float']['output']>;
};

export type BillingNoteUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type BillingNoteUpdateInput = {
  accepted_date?: InputMaybe<Scalars['DateTime']['input']>;
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  attachment_list?: InputMaybe<Array<AttachmentInputObject>>;
  company_type?: InputMaybe<Scalars['String']['input']>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  customer_details: SalesCustomerInputObject;
  customer_unique_id: Scalars['String']['input'];
  delivery_trip_item_list?: InputMaybe<Array<DeliveryTripItemListUpsertInput>>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discount_type?: InputMaybe<Scalars['String']['input']>;
  due_date: Scalars['DateTime']['input'];
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date: Scalars['DateTime']['input'];
  item_list?: InputMaybe<Array<DeliveryTripListUpsertInput>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  related_user_list?: InputMaybe<Array<CreatorInputObject>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_percent?: InputMaybe<Scalars['Float']['input']>;
};

export type BillingNoteView = {
  __typename?: 'BillingNoteView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<CreatorObject>;
  customer_name?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  reference_delivery_trip_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<CreatorObject>>;
  unique_id: Scalars['String']['output'];
};

export type BillingNoteViewsAggrid = {
  __typename?: 'BillingNoteViewsAggrid';
  count: Scalars['Int']['output'];
  results: Array<BillingNoteView>;
};

export type BinLocation = {
  __typename?: 'BinLocation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_3: WarehouseLevel3;
};

export type Car = {
  __typename?: 'Car';
  id?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CompanyUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ContactChannelInputObject = {
  contact_channel_info?: InputMaybe<Scalars['String']['input']>;
  contact_channel_type?: InputMaybe<Scalars['String']['input']>;
};

export type ContactChannelObject = {
  __typename?: 'ContactChannelObject';
  contact_channel_info?: Maybe<Scalars['String']['output']>;
  contact_channel_type?: Maybe<Scalars['String']['output']>;
};

export type CreateInsuranceInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  policy_id?: InputMaybe<Scalars['String']['input']>;
  protection_value?: InputMaybe<Scalars['Decimal']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InsuranceType>;
};

export type CreateTireInput = {
  band?: InputMaybe<Scalars['String']['input']>;
  created_by: CreatorInputObject;
  distance: Scalars['Float']['input'];
  due_distance: Scalars['Float']['input'];
  is_active: Scalars['Boolean']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  price_per_unit?: InputMaybe<Scalars['Decimal']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  serial: Scalars['String']['input'];
};

export type CreateTireResult = {
  __typename?: 'CreateTireResult';
  band?: Maybe<Scalars['String']['output']>;
  created_by: CreatorObject;
  created_date: Scalars['DateTime']['output'];
  current_distance: Scalars['Int']['output'];
  due_distance: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  last_updated_by: CreatorObject;
  last_updated_date: Scalars['DateTime']['output'];
  model?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  serial: Scalars['String']['output'];
  status: Scalars['String']['output'];
  vehicle_id?: Maybe<Scalars['String']['output']>;
};

export type CreateVehicleByInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  img_url: Array<InputMaybe<Scalars['String']['input']>>;
  last_name: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type CreateVehicleDriverInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVehicleImageInput = {
  file_path: Scalars['String']['input'];
  is_primary: Scalars['Boolean']['input'];
};

export type CreatorInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreatorObject = {
  __typename?: 'CreatorObject';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CustomTire = {
  __typename?: 'CustomTire';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TireView>>>;
};

export type CustomTireUsageHistory = {
  __typename?: 'CustomTireUsageHistory';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TireUsageHistoryView>>>;
};

export type CustomVehicle = {
  __typename?: 'CustomVehicle';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<VehicleView>>>;
};

export type DeliveryReportGenerateInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  params?: InputMaybe<Scalars['Json']['input']>;
  report_type: DeliveryReportType;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum DeliveryReportType {
  DeliveryTrip = 'delivery_trip',
  DeliveryTripExpenses = 'delivery_trip_expenses',
  DeliveryTripIncome = 'delivery_trip_income',
  DeliveryTripWork = 'delivery_trip_work'
}

export type DeliveryReportView = {
  __typename?: 'DeliveryReportView';
  actual_end_date?: Maybe<Scalars['DateTime']['output']>;
  actual_start_date?: Maybe<Scalars['DateTime']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_name?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  container_type?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_identity_no?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  end_kilometer?: Maybe<Scalars['Float']['output']>;
  expected_temperature?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Scalars['Int']['output']>;
  fuel_actual_fleet?: Maybe<Scalars['String']['output']>;
  fuel_appa?: Maybe<Scalars['String']['output']>;
  fuel_other?: Maybe<Scalars['String']['output']>;
  fuel_price?: Maybe<Scalars['Float']['output']>;
  fuel_total_quota?: Maybe<Scalars['String']['output']>;
  fuel_total_usage?: Maybe<Scalars['String']['output']>;
  is_frozen?: Maybe<Scalars['Boolean']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_amount?: Maybe<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  job_no?: Maybe<Scalars['String']['output']>;
  plan_distance?: Maybe<Scalars['Float']['output']>;
  plan_end_date?: Maybe<Scalars['DateTime']['output']>;
  plan_start_date?: Maybe<Scalars['DateTime']['output']>;
  primary_driver_name?: Maybe<Scalars['String']['output']>;
  reference_document?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  related_user_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  route_code?: Maybe<Scalars['String']['output']>;
  secondary_driver_name?: Maybe<Scalars['String']['output']>;
  start_kilometer?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  temperature_end_hours?: Maybe<Scalars['Float']['output']>;
  temperature_start_hours?: Maybe<Scalars['Float']['output']>;
  temperature_type?: Maybe<Scalars['String']['output']>;
  total_kilometer_distance?: Maybe<Scalars['Float']['output']>;
  total_temperature_hours?: Maybe<Scalars['Float']['output']>;
  trailer_license_plate?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  vehicle_no?: Maybe<Scalars['String']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
};

export type DeliveryReportViewAggridOutput = {
  __typename?: 'DeliveryReportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<DeliveryReportView>;
};

export type DeliveryTrip = {
  __typename?: 'DeliveryTrip';
  actual_end_date?: Maybe<Scalars['DateTime']['output']>;
  actual_start_date?: Maybe<Scalars['DateTime']['output']>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  attachment_list?: Maybe<Array<Scalars['Json']['output']>>;
  container_type?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  created_payment_date?: Maybe<Scalars['DateTime']['output']>;
  customer_details: Scalars['Json']['output'];
  customer_unique_id: Scalars['String']['output'];
  drop_cost: Scalars['Float']['output'];
  end_kilometer?: Maybe<Scalars['Float']['output']>;
  expected_temperature?: Maybe<Scalars['String']['output']>;
  expenses_list?: Maybe<Array<ExpensesList>>;
  expenses_net_amount: Scalars['Float']['output'];
  expenses_post_discount_amount: Scalars['Float']['output'];
  expenses_total_amount: Scalars['Float']['output'];
  expenses_vat_0_percent_amount: Scalars['Float']['output'];
  expenses_vat_7_percent_amount: Scalars['Float']['output'];
  expenses_vat_amount: Scalars['Float']['output'];
  expenses_vat_exempted_amount: Scalars['Float']['output'];
  expenses_withholding_tax_amount: Scalars['Float']['output'];
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  fuel?: Maybe<Scalars['Json']['output']>;
  fuel_price?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  income_list?: Maybe<Array<IncomeList>>;
  income_net_amount: Scalars['Float']['output'];
  income_post_discount_amount: Scalars['Float']['output'];
  income_total_amount: Scalars['Float']['output'];
  income_vat_0_percent_amount: Scalars['Float']['output'];
  income_vat_7_percent_amount: Scalars['Float']['output'];
  income_vat_amount: Scalars['Float']['output'];
  income_vat_exempted_amount: Scalars['Float']['output'];
  income_withholding_tax_amount: Scalars['Float']['output'];
  is_frozen?: Maybe<Scalars['Boolean']['output']>;
  issue_date: Scalars['DateTime']['output'];
  item_amount?: Maybe<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  job_no: Scalars['String']['output'];
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  max_shipping_cost: Scalars['Float']['output'];
  packaging_location?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['DateTime']['output']>;
  payment_detail?: Maybe<Scalars['String']['output']>;
  payment_status?: Maybe<Scalars['Boolean']['output']>;
  plan_distance?: Maybe<Scalars['Float']['output']>;
  plan_end_date?: Maybe<Scalars['DateTime']['output']>;
  plan_start_date?: Maybe<Scalars['DateTime']['output']>;
  primary_driver: Scalars['Json']['output'];
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  related_user_list: Array<Scalars['Json']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  route_code?: Maybe<Scalars['String']['output']>;
  secondary_driver?: Maybe<Scalars['Json']['output']>;
  secondary_driver_cost: Scalars['Float']['output'];
  start_kilometer?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  temperature_end_hours?: Maybe<Scalars['Float']['output']>;
  temperature_start_hours?: Maybe<Scalars['Float']['output']>;
  temperature_type?: Maybe<Scalars['String']['output']>;
  total_kilometer_distance?: Maybe<Scalars['Float']['output']>;
  total_temperature_hours?: Maybe<Scalars['Float']['output']>;
  trailer?: Maybe<Scalars['Json']['output']>;
  trailer_id?: Maybe<Scalars['Int']['output']>;
  unique_id: Scalars['String']['output'];
  vehicle: Scalars['Json']['output'];
  vehicle_id: Scalars['Int']['output'];
  work_list?: Maybe<Array<WorkList>>;
  work_total_amount: Scalars['Float']['output'];
};

/** One column of one sheet. The sheet builds its header row from these. */
export type DeliveryTripBulkColumn = {
  __typename?: 'DeliveryTripBulkColumn';
  decimals?: Maybe<Scalars['Int']['output']>;
  dependency?: Maybe<Scalars['Boolean']['output']>;
  editable: Scalars['Boolean']['output'];
  field: Scalars['String']['output'];
  formula?: Maybe<Scalars['Boolean']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  master?: Maybe<Scalars['String']['output']>;
  positive?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sheet: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DeliveryTripBulkColumnSet = {
  __typename?: 'DeliveryTripBulkColumnSet';
  delivery_trip: Array<DeliveryTripBulkColumn>;
  expenses_list: Array<DeliveryTripBulkColumn>;
  income_list: Array<DeliveryTripBulkColumn>;
  work_list: Array<DeliveryTripBulkColumn>;
};

export type DeliveryTripBulkExpensesListInput = {
  driver_no: Scalars['String']['input'];
  fields?: InputMaybe<Scalars['Json']['input']>;
  index: Scalars['Int']['input'];
  row: Scalars['Int']['input'];
};

export type DeliveryTripBulkFetchResult = {
  __typename?: 'DeliveryTripBulkFetchResult';
  columns: DeliveryTripBulkColumnSet;
  contract_version: Scalars['String']['output'];
  /** Rows are pre-flattened to the contract's field paths; Json keeps that shape honest. */
  delivery_trips: Array<Scalars['Json']['output']>;
  expenses_lists: Array<Scalars['Json']['output']>;
  fetched_at: Scalars['DateTime']['output'];
  fetched_by: Scalars['String']['output'];
  income_lists: Array<Scalars['Json']['output']>;
  total_count: Scalars['Int']['output'];
  work_lists: Array<Scalars['Json']['output']>;
};

export type DeliveryTripBulkFieldError = {
  __typename?: 'DeliveryTripBulkFieldError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type DeliveryTripBulkFilterInput = {
  /**
   * The officer's own choice in the fetch dialog — a plain filter, not a
   * permission. Null or empty means every customer, which is what
   * "ลูกค้าทั้งหมด" selects. The sheet token carries no data scope, so this does
   * not narrow against anything; AC 23 is unenforced backend-wide today.
   */
  customer_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date_from: Scalars['DateTime']['input'];
  issue_date_to: Scalars['DateTime']['input'];
};

export type DeliveryTripBulkImportInput = {
  /** Stable across retries within one sync run — what makes AC 17 hold. */
  batch_id: Scalars['String']['input'];
  /** Rejected if it does not match the server's CONTRACT_VERSION. */
  contract_version: Scalars['String']['input'];
  data: Array<DeliveryTripBulkUpdateInput>;
};

/** Same envelope as the existing importers — but `detail` is populated. */
export type DeliveryTripBulkImportResult = {
  __typename?: 'DeliveryTripBulkImportResult';
  batch_id: Scalars['String']['output'];
  detail: Array<DeliveryTripBulkRowResult>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type DeliveryTripBulkMasterResult = {
  __typename?: 'DeliveryTripBulkMasterResult';
  driver_no: Array<Scalars['String']['output']>;
  main_status: Array<Scalars['String']['output']>;
  service_item: Array<Scalars['Json']['output']>;
  temperature_type: Array<Scalars['String']['output']>;
  uom: Array<Scalars['String']['output']>;
  vehicle_type: Array<Scalars['String']['output']>;
  withholding_tax_type: Array<Scalars['String']['output']>;
  work_type: Array<Scalars['String']['output']>;
};

export type DeliveryTripBulkPreview = {
  __typename?: 'DeliveryTripBulkPreview';
  customer_count: Scalars['Int']['output'];
  delivery_trip_count: Scalars['Int']['output'];
  work_list_count: Scalars['Int']['output'];
};

export type DeliveryTripBulkRowResult = {
  __typename?: 'DeliveryTripBulkRowResult';
  errors?: Maybe<Array<DeliveryTripBulkFieldError>>;
  /**
   * The document's concurrency token AFTER this write. The client stores it back
   * into the hidden `_updated_at` column so a follow-up sync of the same rows is
   * not rejected as STALE by the write this very call just made.
   */
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  /** OK | FAIL | SKIP | STALE — mirrors the sheet's log column. */
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  unique_id: Scalars['String']['output'];
};

export type DeliveryTripBulkUpdateInput = {
  expenses_list?: InputMaybe<Array<DeliveryTripBulkExpensesListInput>>;
  /** Editable DT header fields, keyed by the contract's field paths. */
  fields?: InputMaybe<Scalars['Json']['input']>;
  /**
   * The `_updated_at` value this document was fetched with. If the stored value has
   * moved, the document is rejected as STALE rather than overwritten.
   */
  last_updated_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Sheet row number, echoed back untouched so the client can paint it (AC 19). */
  row: Scalars['Int']['input'];
  unique_id: Scalars['String']['input'];
  work_list?: InputMaybe<Array<DeliveryTripBulkWorkListInput>>;
};

export type DeliveryTripBulkValidateResult = {
  __typename?: 'DeliveryTripBulkValidateResult';
  cancelled_unique_id_list: Array<Scalars['String']['output']>;
  contract_version: Scalars['String']['output'];
  detail: Array<DeliveryTripBulkRowResult>;
  missing_delivery_trip_unique_id_list: Array<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  stale_unique_id_list: Array<Scalars['String']['output']>;
  unmatched_expenses_keys: Array<Scalars['String']['output']>;
  unmatched_work_list_keys: Array<Scalars['String']['output']>;
};

export type DeliveryTripBulkWorkListInput = {
  fields?: InputMaybe<Scalars['Json']['input']>;
  /** Join key. A stop with no match is rejected, never created (AC 15). */
  index: Scalars['Int']['input'];
  row: Scalars['Int']['input'];
};

export type DeliveryTripCreateInput = {
  actual_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  actual_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  container_type?: InputMaybe<Scalars['String']['input']>;
  created_by: Scalars['Json']['input'];
  created_payment_date?: InputMaybe<Scalars['DateTime']['input']>;
  customer_details: Scalars['Json']['input'];
  customer_unique_id: Scalars['String']['input'];
  drop_cost: Scalars['Float']['input'];
  end_kilometer?: InputMaybe<Scalars['Float']['input']>;
  expected_temperature?: InputMaybe<Scalars['String']['input']>;
  expenses_list?: InputMaybe<Array<ExpensesListCreateInput>>;
  expenses_net_amount: Scalars['Float']['input'];
  expenses_post_discount_amount: Scalars['Float']['input'];
  expenses_total_amount: Scalars['Float']['input'];
  expenses_vat_0_percent_amount: Scalars['Float']['input'];
  expenses_vat_7_percent_amount: Scalars['Float']['input'];
  expenses_vat_amount: Scalars['Float']['input'];
  expenses_vat_exempted_amount: Scalars['Float']['input'];
  expenses_withholding_tax_amount: Scalars['Float']['input'];
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  fuel?: InputMaybe<Scalars['Json']['input']>;
  fuel_price?: InputMaybe<Scalars['Float']['input']>;
  income_list?: InputMaybe<Array<IncomeListCreateInput>>;
  income_net_amount: Scalars['Float']['input'];
  income_post_discount_amount: Scalars['Float']['input'];
  income_total_amount: Scalars['Float']['input'];
  income_vat_0_percent_amount: Scalars['Float']['input'];
  income_vat_7_percent_amount: Scalars['Float']['input'];
  income_vat_amount: Scalars['Float']['input'];
  income_vat_exempted_amount: Scalars['Float']['input'];
  income_withholding_tax_amount: Scalars['Float']['input'];
  is_frozen?: InputMaybe<Scalars['Boolean']['input']>;
  issue_date: Scalars['DateTime']['input'];
  item_amount?: InputMaybe<Scalars['String']['input']>;
  item_type?: InputMaybe<Scalars['String']['input']>;
  job_no: Scalars['String']['input'];
  main_status: Scalars['String']['input'];
  max_shipping_cost: Scalars['Float']['input'];
  packaging_location?: InputMaybe<Scalars['String']['input']>;
  payment_date?: InputMaybe<Scalars['DateTime']['input']>;
  payment_detail?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['Boolean']['input']>;
  plan_distance?: InputMaybe<Scalars['Float']['input']>;
  plan_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  plan_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  primary_driver?: InputMaybe<Scalars['Json']['input']>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  related_user_list: Array<Scalars['Json']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  route_code?: InputMaybe<Scalars['String']['input']>;
  secondary_driver?: InputMaybe<Scalars['Json']['input']>;
  secondary_driver_cost: Scalars['Float']['input'];
  start_kilometer?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  temperature_end_hours?: InputMaybe<Scalars['Float']['input']>;
  temperature_start_hours?: InputMaybe<Scalars['Float']['input']>;
  temperature_type?: InputMaybe<Scalars['String']['input']>;
  total_kilometer_distance?: InputMaybe<Scalars['Float']['input']>;
  total_temperature_hours?: InputMaybe<Scalars['Float']['input']>;
  trailer?: InputMaybe<Scalars['Json']['input']>;
  trailer_id?: InputMaybe<Scalars['Int']['input']>;
  unique_id: Scalars['String']['input'];
  vehicle: Scalars['Json']['input'];
  vehicle_id?: InputMaybe<Scalars['Int']['input']>;
  work_list?: InputMaybe<Array<WorkListCreateInput>>;
  work_total_amount: Scalars['Float']['input'];
};

export type DeliveryTripExpensesReportView = {
  __typename?: 'DeliveryTripExpensesReportView';
  actual_end_date?: Maybe<Scalars['DateTime']['output']>;
  actual_start_date?: Maybe<Scalars['DateTime']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_name?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  container_type?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  created_payment_date?: Maybe<Scalars['DateTime']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_identity_no?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  driver_name?: Maybe<Scalars['String']['output']>;
  driver_no?: Maybe<DriverNo>;
  end_kilometer?: Maybe<Scalars['Float']['output']>;
  expected_temperature?: Maybe<Scalars['String']['output']>;
  expenses_net_amount?: Maybe<Scalars['Float']['output']>;
  expenses_post_discount_amount?: Maybe<Scalars['Float']['output']>;
  expenses_total_amount?: Maybe<Scalars['Float']['output']>;
  expenses_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  expenses_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  expenses_vat_amount?: Maybe<Scalars['Float']['output']>;
  expenses_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  expenses_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  flag_status?: Maybe<Scalars['Int']['output']>;
  fuel_actual_fleet?: Maybe<Scalars['String']['output']>;
  fuel_appa?: Maybe<Scalars['String']['output']>;
  fuel_other?: Maybe<Scalars['String']['output']>;
  fuel_price?: Maybe<Scalars['Float']['output']>;
  fuel_total_quota?: Maybe<Scalars['String']['output']>;
  fuel_total_usage?: Maybe<Scalars['String']['output']>;
  is_frozen?: Maybe<Scalars['Boolean']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_amount?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  job_no?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  payment_date?: Maybe<Scalars['DateTime']['output']>;
  payment_detail?: Maybe<Scalars['String']['output']>;
  payment_status?: Maybe<Scalars['Boolean']['output']>;
  plan_distance?: Maybe<Scalars['Float']['output']>;
  plan_end_date?: Maybe<Scalars['DateTime']['output']>;
  plan_start_date?: Maybe<Scalars['DateTime']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  primary_driver_name?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  reference_document?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  related_user_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  route_code?: Maybe<Scalars['String']['output']>;
  secondary_driver_name?: Maybe<Scalars['String']['output']>;
  start_kilometer?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  temperature_end_hours?: Maybe<Scalars['Float']['output']>;
  temperature_start_hours?: Maybe<Scalars['Float']['output']>;
  temperature_type?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  total_kilometer_distance?: Maybe<Scalars['Float']['output']>;
  total_temperature_hours?: Maybe<Scalars['Float']['output']>;
  trailer_license_plate?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  vehicle_no?: Maybe<Scalars['String']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
};

export type DeliveryTripExpensesReportViewAggridOutput = {
  __typename?: 'DeliveryTripExpensesReportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<DeliveryTripExpensesReportView>;
};

export type DeliveryTripForBillingNoteView = {
  __typename?: 'DeliveryTripForBillingNoteView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  billing_note_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  billing_total_amount?: Maybe<Scalars['Float']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  exceed_total_amount?: Maybe<Scalars['Boolean']['output']>;
  expenses_net_amount?: Maybe<Scalars['Float']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  has_billing_note?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  income_net_amount?: Maybe<Scalars['Float']['output']>;
  income_post_discount_amount?: Maybe<Scalars['Float']['output']>;
  income_total_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  income_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  trailer_license_plate?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  vehicle?: Maybe<Scalars['Json']['output']>;
  vehicle_id?: Maybe<Scalars['Int']['output']>;
  vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  vehicle_no?: Maybe<Scalars['String']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
  work_list: Array<Scalars['Json']['output']>;
};

export type DeliveryTripForBillingNoteViewAggrid = {
  __typename?: 'DeliveryTripForBillingNoteViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<DeliveryTripForBillingNoteView>;
};

export type DeliveryTripIncomeReportView = {
  __typename?: 'DeliveryTripIncomeReportView';
  actual_end_date?: Maybe<Scalars['DateTime']['output']>;
  actual_start_date?: Maybe<Scalars['DateTime']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_name?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  container_type?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_identity_no?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  end_kilometer?: Maybe<Scalars['Float']['output']>;
  expected_temperature?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Scalars['Int']['output']>;
  fuel_actual_fleet?: Maybe<Scalars['String']['output']>;
  fuel_appa?: Maybe<Scalars['String']['output']>;
  fuel_other?: Maybe<Scalars['String']['output']>;
  fuel_price?: Maybe<Scalars['Float']['output']>;
  fuel_total_quota?: Maybe<Scalars['String']['output']>;
  fuel_total_usage?: Maybe<Scalars['String']['output']>;
  income_net_amount?: Maybe<Scalars['Float']['output']>;
  income_post_discount_amount?: Maybe<Scalars['Float']['output']>;
  income_total_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  income_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  is_frozen?: Maybe<Scalars['Boolean']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_amount?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  job_no?: Maybe<Scalars['String']['output']>;
  plan_distance?: Maybe<Scalars['Float']['output']>;
  plan_end_date?: Maybe<Scalars['DateTime']['output']>;
  plan_start_date?: Maybe<Scalars['DateTime']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  primary_driver_name?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  reference_document?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  related_user_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  route_code?: Maybe<Scalars['String']['output']>;
  secondary_driver_name?: Maybe<Scalars['String']['output']>;
  start_kilometer?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  temperature_end_hours?: Maybe<Scalars['Float']['output']>;
  temperature_start_hours?: Maybe<Scalars['Float']['output']>;
  temperature_type?: Maybe<Scalars['String']['output']>;
  total_kilometer_distance?: Maybe<Scalars['Float']['output']>;
  total_temperature_hours?: Maybe<Scalars['Float']['output']>;
  trailer_license_plate?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  vehicle_no?: Maybe<Scalars['String']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
};

export type DeliveryTripIncomeReportViewAggridOutput = {
  __typename?: 'DeliveryTripIncomeReportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<DeliveryTripIncomeReportView>;
};

export type DeliveryTripItemList = {
  __typename?: 'DeliveryTripItemList';
  description?: Maybe<Scalars['String']['output']>;
  dt_fuel_price?: Maybe<Scalars['Float']['output']>;
  dt_issue_date: Scalars['DateTime']['output'];
  dt_job_no?: Maybe<Scalars['String']['output']>;
  dt_unique_id: Scalars['String']['output'];
  dt_vehicle_id: Scalars['Int']['output'];
  dt_vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  dt_vehicle_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  income_item_name?: Maybe<Scalars['String']['output']>;
  income_item_pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  income_item_unique_id?: Maybe<Scalars['String']['output']>;
  income_unique_id: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
};

export type DeliveryTripItemListCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dt_fuel_price?: InputMaybe<Scalars['Float']['input']>;
  dt_issue_date: Scalars['DateTime']['input'];
  dt_job_no?: InputMaybe<Scalars['String']['input']>;
  dt_unique_id: Scalars['String']['input'];
  dt_vehicle_id: Scalars['Int']['input'];
  dt_vehicle_license_plate?: InputMaybe<Scalars['String']['input']>;
  dt_vehicle_type?: InputMaybe<Scalars['String']['input']>;
  income_item_name?: InputMaybe<Scalars['String']['input']>;
  income_item_pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  income_item_unique_id?: InputMaybe<Scalars['String']['input']>;
  income_unique_id: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
};

export type DeliveryTripItemListUpsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dt_fuel_price?: InputMaybe<Scalars['Float']['input']>;
  dt_issue_date: Scalars['DateTime']['input'];
  dt_job_no?: InputMaybe<Scalars['String']['input']>;
  dt_unique_id: Scalars['String']['input'];
  dt_vehicle_id: Scalars['Int']['input'];
  dt_vehicle_license_plate?: InputMaybe<Scalars['String']['input']>;
  dt_vehicle_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  income_item_name?: InputMaybe<Scalars['String']['input']>;
  income_item_pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  income_item_unique_id?: InputMaybe<Scalars['String']['input']>;
  income_unique_id: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
};

export type DeliveryTripItemListView = {
  __typename?: 'DeliveryTripItemListView';
  dt_aggrid_status?: Maybe<Scalars['String']['output']>;
  dt_customer_id?: Maybe<Scalars['Int']['output']>;
  dt_customer_name?: Maybe<Scalars['String']['output']>;
  dt_fuel_price?: Maybe<Scalars['Float']['output']>;
  dt_issue_date: Scalars['DateTime']['output'];
  dt_job_no?: Maybe<Scalars['String']['output']>;
  dt_main_status?: Maybe<Scalars['String']['output']>;
  dt_reference_unique_id?: Maybe<Scalars['String']['output']>;
  dt_unique_id: Scalars['String']['output'];
  dt_vehicle_id: Scalars['Int']['output'];
  dt_vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  dt_vehicle_type?: Maybe<Scalars['String']['output']>;
  dt_work_list?: Maybe<Scalars['String']['output']>;
  income_item_description?: Maybe<Scalars['String']['output']>;
  income_item_name?: Maybe<Scalars['String']['output']>;
  income_item_pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  income_item_unique_id?: Maybe<Scalars['String']['output']>;
  income_unique_id: Scalars['String']['output'];
};

export type DeliveryTripItemListViewsAggrid = {
  __typename?: 'DeliveryTripItemListViewsAggrid';
  count: Scalars['Int']['output'];
  results: Array<DeliveryTripItemListView>;
};

export type DeliveryTripList = {
  __typename?: 'DeliveryTripList';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  customer_details: SalesCustomerObject;
  description?: Maybe<Scalars['String']['output']>;
  destination_location?: Maybe<Scalars['String']['output']>;
  dt_income_post_discount_amount: Scalars['Float']['output'];
  dt_income_unique_id: Scalars['String']['output'];
  dt_income_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  dt_reference_unique_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  income_net_amount?: Maybe<Scalars['Float']['output']>;
  income_post_discount_amount: Scalars['Float']['output'];
  income_total_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_amount?: Maybe<Scalars['Float']['output']>;
  income_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  income_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  issue_date: Scalars['DateTime']['output'];
  source_location?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  vehicle_details?: Maybe<Scalars['Json']['output']>;
  vehicle_id: Scalars['Int']['output'];
};

export type DeliveryTripListCreateInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  customer_details: SalesCustomerInputObject;
  description?: InputMaybe<Scalars['String']['input']>;
  destination_location?: InputMaybe<Scalars['String']['input']>;
  dt_income_post_discount_amount: Scalars['Float']['input'];
  dt_income_unique_id: Scalars['String']['input'];
  dt_income_withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  dt_reference_unique_id: Scalars['String']['input'];
  income_net_amount?: InputMaybe<Scalars['Float']['input']>;
  income_post_discount_amount: Scalars['Float']['input'];
  income_total_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  income_withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  issue_date: Scalars['DateTime']['input'];
  source_location?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
  vehicle_details?: InputMaybe<Scalars['Json']['input']>;
  vehicle_id: Scalars['Int']['input'];
};

export type DeliveryTripListUpsertInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  customer_details: SalesCustomerInputObject;
  description?: InputMaybe<Scalars['String']['input']>;
  destination_location?: InputMaybe<Scalars['String']['input']>;
  dt_income_post_discount_amount: Scalars['Float']['input'];
  dt_income_unique_id: Scalars['String']['input'];
  dt_income_withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  dt_reference_unique_id: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  income_net_amount?: InputMaybe<Scalars['Float']['input']>;
  income_post_discount_amount: Scalars['Float']['input'];
  income_total_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  income_withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  issue_date: Scalars['DateTime']['input'];
  source_location?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
  vehicle_details?: InputMaybe<Scalars['Json']['input']>;
  vehicle_id: Scalars['Int']['input'];
};

export type DeliveryTripUpdateInput = {
  actual_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  actual_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  container_type?: InputMaybe<Scalars['String']['input']>;
  created_payment_date?: InputMaybe<Scalars['DateTime']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  drop_cost?: InputMaybe<Scalars['Float']['input']>;
  end_kilometer?: InputMaybe<Scalars['Float']['input']>;
  expected_temperature?: InputMaybe<Scalars['String']['input']>;
  expenses_list?: InputMaybe<Array<ExpensesListUpsertInput>>;
  expenses_net_amount?: InputMaybe<Scalars['Float']['input']>;
  expenses_post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  expenses_total_amount?: InputMaybe<Scalars['Float']['input']>;
  expenses_vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  expenses_vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  expenses_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  expenses_vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  expenses_withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  fuel?: InputMaybe<Scalars['Json']['input']>;
  fuel_price?: InputMaybe<Scalars['Float']['input']>;
  income_list?: InputMaybe<Array<IncomeListUpsertInput>>;
  income_net_amount?: InputMaybe<Scalars['Float']['input']>;
  income_post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  income_total_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  income_vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  income_withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  is_frozen?: InputMaybe<Scalars['Boolean']['input']>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_amount?: InputMaybe<Scalars['String']['input']>;
  item_type?: InputMaybe<Scalars['String']['input']>;
  job_no?: InputMaybe<Scalars['String']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status: Scalars['String']['input'];
  max_shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  packaging_location?: InputMaybe<Scalars['String']['input']>;
  payment_date?: InputMaybe<Scalars['DateTime']['input']>;
  payment_detail?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['Boolean']['input']>;
  plan_distance?: InputMaybe<Scalars['Float']['input']>;
  plan_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  plan_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  primary_driver?: InputMaybe<Scalars['Json']['input']>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  route_code?: InputMaybe<Scalars['String']['input']>;
  secondary_driver?: InputMaybe<Scalars['Json']['input']>;
  secondary_driver_cost?: InputMaybe<Scalars['Float']['input']>;
  start_kilometer?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  temperature_end_hours?: InputMaybe<Scalars['Float']['input']>;
  temperature_start_hours?: InputMaybe<Scalars['Float']['input']>;
  temperature_type?: InputMaybe<Scalars['String']['input']>;
  total_kilometer_distance?: InputMaybe<Scalars['Float']['input']>;
  total_temperature_hours?: InputMaybe<Scalars['Float']['input']>;
  trailer?: InputMaybe<Scalars['Json']['input']>;
  trailer_id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vehicle?: InputMaybe<Scalars['Json']['input']>;
  vehicle_id?: InputMaybe<Scalars['Int']['input']>;
  work_list?: InputMaybe<Array<WorkListUpsertInput>>;
  work_total_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type DeliveryTripView = {
  __typename?: 'DeliveryTripView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Array<Scalars['String']['output']>>;
  driver_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  expenses_total_amount?: Maybe<Scalars['Float']['output']>;
  flag_payment_status?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  fuel_price?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  income_total_amount?: Maybe<Scalars['Float']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['DateTime']['output']>;
  payment_status?: Maybe<Scalars['Boolean']['output']>;
  plan_distance?: Maybe<Scalars['Float']['output']>;
  plan_end_date?: Maybe<Scalars['DateTime']['output']>;
  plan_start_date?: Maybe<Scalars['DateTime']['output']>;
  reference_quotation_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  route_code?: Maybe<Scalars['String']['output']>;
  temperature_type?: Maybe<Scalars['String']['output']>;
  trailer_license_plate?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['Int']['output']>;
  vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  vehicle_no?: Maybe<Scalars['String']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
};

export type DeliveryTripViewAggrid = {
  __typename?: 'DeliveryTripViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<DeliveryTripView>;
};

export type DeliveryTripWorkReportView = {
  __typename?: 'DeliveryTripWorkReportView';
  actual_end_date?: Maybe<Scalars['DateTime']['output']>;
  actual_start_date?: Maybe<Scalars['DateTime']['output']>;
  arrived_kilometer?: Maybe<Scalars['Float']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_name?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  container_type?: Maybe<Scalars['String']['output']>;
  coordinator_name?: Maybe<Scalars['String']['output']>;
  coordinator_phone?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_identity_no?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  drop_cost?: Maybe<Scalars['Float']['output']>;
  end_kilometer?: Maybe<Scalars['Float']['output']>;
  expected_temperature?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Scalars['Int']['output']>;
  fuel_actual_fleet?: Maybe<Scalars['String']['output']>;
  fuel_appa?: Maybe<Scalars['String']['output']>;
  fuel_other?: Maybe<Scalars['String']['output']>;
  fuel_price?: Maybe<Scalars['Float']['output']>;
  fuel_total_quota?: Maybe<Scalars['String']['output']>;
  fuel_total_usage?: Maybe<Scalars['String']['output']>;
  is_frozen?: Maybe<Scalars['Boolean']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_amount?: Maybe<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  job_no?: Maybe<Scalars['String']['output']>;
  l_id?: Maybe<Scalars['Int']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  location_unique_id?: Maybe<Scalars['String']['output']>;
  max_shipping_cost?: Maybe<Scalars['Float']['output']>;
  plan_distance?: Maybe<Scalars['Float']['output']>;
  plan_end_date?: Maybe<Scalars['DateTime']['output']>;
  plan_start_date?: Maybe<Scalars['DateTime']['output']>;
  primary_driver_name?: Maybe<Scalars['String']['output']>;
  reference_code?: Maybe<Scalars['String']['output']>;
  reference_document?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  related_user_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  route_code?: Maybe<Scalars['String']['output']>;
  seal_no?: Maybe<Scalars['String']['output']>;
  secondary_driver_cost?: Maybe<Scalars['Float']['output']>;
  secondary_driver_name?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  special_request?: Maybe<Scalars['String']['output']>;
  start_kilometer?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  temperature_end_hours?: Maybe<Scalars['Float']['output']>;
  temperature_start_hours?: Maybe<Scalars['Float']['output']>;
  temperature_type?: Maybe<Scalars['String']['output']>;
  total_kilometer_distance?: Maybe<Scalars['Float']['output']>;
  total_temperature_hours?: Maybe<Scalars['Float']['output']>;
  trailer_license_plate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  vehicle_no?: Maybe<Scalars['String']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
  work_customer_name?: Maybe<Scalars['String']['output']>;
  work_end_date?: Maybe<Scalars['DateTime']['output']>;
  work_total_amount?: Maybe<Scalars['Float']['output']>;
};

export type DeliveryTripWorkReportViewAggridOutput = {
  __typename?: 'DeliveryTripWorkReportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<DeliveryTripWorkReportView>;
};

export type DeliveryUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum DriverNo {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type ExpensesList = {
  __typename?: 'ExpensesList';
  discount: Scalars['Float']['output'];
  driver_no?: Maybe<DriverNo>;
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  item_id: Scalars['Int']['output'];
  item_name: Scalars['String']['output'];
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_unique_id: Scalars['String']['output'];
  net_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount: Scalars['Float']['output'];
  price_per_unit: Scalars['Float']['output'];
  qty?: Maybe<Scalars['Float']['output']>;
  reference_unique_id: Scalars['String']['output'];
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  uom_conversion_list?: Maybe<Array<Scalars['Json']['output']>>;
  uom_id: Scalars['Int']['output'];
  uom_name: Scalars['String']['output'];
  vat_percentage: Scalars['String']['output'];
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type ExpensesListCreateInput = {
  discount: Scalars['Float']['input'];
  driver_no?: InputMaybe<DriverNo>;
  index: Scalars['Int']['input'];
  item_id: Scalars['Int']['input'];
  item_name: Scalars['String']['input'];
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_unique_id: Scalars['String']['input'];
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount: Scalars['Float']['input'];
  price_per_unit: Scalars['Float']['input'];
  qty?: InputMaybe<Scalars['Float']['input']>;
  reference_unique_id: Scalars['String']['input'];
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  uom_id: Scalars['Int']['input'];
  uom_name: Scalars['String']['input'];
  vat_percentage: Scalars['String']['input'];
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type ExpensesListFindManyInput = {
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ExpensesListUpsertInput = {
  discount: Scalars['Float']['input'];
  driver_no?: InputMaybe<DriverNo>;
  id?: InputMaybe<Scalars['Int']['input']>;
  index: Scalars['Int']['input'];
  item_id: Scalars['Int']['input'];
  item_name: Scalars['String']['input'];
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_unique_id: Scalars['String']['input'];
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount: Scalars['Float']['input'];
  price_per_unit: Scalars['Float']['input'];
  qty?: InputMaybe<Scalars['Float']['input']>;
  reference_unique_id: Scalars['String']['input'];
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  uom_id: Scalars['Int']['input'];
  uom_name: Scalars['String']['input'];
  vat_percentage: Scalars['String']['input'];
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type GanttChartVehicleResponse = {
  __typename?: 'GanttChartVehicleResponse';
  car?: Maybe<Car>;
  remark?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  today_task?: Maybe<Scalars['Boolean']['output']>;
};

export enum GanttChartVehicleStatus {
  All = 'all',
  Available = 'available',
  InActive = 'in_active',
  InProgress = 'in_progress',
  Incident = 'incident',
  Maintenance = 'maintenance'
}

export type GeneralExportInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageUrlInputObjectInput = {
  img_url?: InputMaybe<Scalars['String']['input']>;
  is_main_img?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageUrlObject = {
  __typename?: 'ImageUrlObject';
  img_url?: Maybe<Scalars['String']['output']>;
  is_main_img?: Maybe<Scalars['Boolean']['output']>;
};

export type IncomeList = {
  __typename?: 'IncomeList';
  discount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  item_id: Scalars['Int']['output'];
  item_name: Scalars['String']['output'];
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_unique_id: Scalars['String']['output'];
  pre_vat_amount: Scalars['Float']['output'];
  price_per_unit: Scalars['Float']['output'];
  qty?: Maybe<Scalars['Float']['output']>;
  reference_line_item?: Maybe<Scalars['Json']['output']>;
  reference_unique_id: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  uom_conversion_list?: Maybe<Array<Scalars['Json']['output']>>;
  uom_id: Scalars['Int']['output'];
  uom_name: Scalars['String']['output'];
  vat_percentage: Scalars['String']['output'];
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type IncomeListCreateInput = {
  discount: Scalars['Float']['input'];
  index: Scalars['Int']['input'];
  item_id: Scalars['Int']['input'];
  item_name: Scalars['String']['input'];
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_unique_id: Scalars['String']['input'];
  pre_vat_amount: Scalars['Float']['input'];
  price_per_unit: Scalars['Float']['input'];
  qty?: InputMaybe<Scalars['Float']['input']>;
  reference_line_item?: InputMaybe<Scalars['Json']['input']>;
  reference_unique_id: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  uom_id: Scalars['Int']['input'];
  uom_name: Scalars['String']['input'];
  vat_percentage: Scalars['String']['input'];
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type IncomeListFindManyInput = {
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type IncomeListUpsertInput = {
  discount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  index: Scalars['Int']['input'];
  item_id: Scalars['Int']['input'];
  item_name: Scalars['String']['input'];
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_unique_id: Scalars['String']['input'];
  pre_vat_amount: Scalars['Float']['input'];
  price_per_unit: Scalars['Float']['input'];
  qty?: InputMaybe<Scalars['Float']['input']>;
  reference_line_item?: InputMaybe<Scalars['Json']['input']>;
  reference_unique_id: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  uom_id: Scalars['Int']['input'];
  uom_name: Scalars['String']['input'];
  vat_percentage: Scalars['String']['input'];
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type InsuranceDetail = {
  __typename?: 'InsuranceDetail';
  end_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  policy_id?: Maybe<Scalars['String']['output']>;
  protection_value?: Maybe<Scalars['Decimal']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  type?: Maybe<InsuranceType>;
};

export enum InsuranceType {
  Product = 'product',
  Vehicle = 'vehicle'
}

export type InsuranceUpdateInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  policy_id?: InputMaybe<Scalars['String']['input']>;
  protection_value?: InputMaybe<Scalars['Decimal']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InsuranceType>;
};

export type InventorySetting = {
  __typename?: 'InventorySetting';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: InventorySettingType;
};

export enum InventorySettingType {
  Cate_1 = 'cate_1',
  Cate_2 = 'cate_2',
  Cate_3 = 'cate_3',
  Unit = 'unit'
}

export type Maintenance = {
  __typename?: 'Maintenance';
  accident_date?: Maybe<Scalars['DateTime']['output']>;
  accident_description?: Maybe<Scalars['String']['output']>;
  accident_location?: Maybe<Scalars['String']['output']>;
  additional_discount: Scalars['Float']['output'];
  additional_discount_type: MaintenanceDiscountType;
  aggrid_status: Scalars['String']['output'];
  attachment_list?: Maybe<Array<Scalars['Json']['output']>>;
  claim_attachment_list?: Maybe<Array<Scalars['Json']['output']>>;
  claim_no?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  driver_list?: Maybe<Array<Scalars['Json']['output']>>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_insurance_fully_paid?: Maybe<Scalars['Boolean']['output']>;
  issue_date: Scalars['DateTime']['output'];
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  ma_details: Scalars['Json']['output'];
  ma_end_date?: Maybe<Scalars['DateTime']['output']>;
  ma_item_list?: Maybe<Array<MaintenanceItem>>;
  ma_list?: Maybe<Array<MaintenanceTask>>;
  ma_start_date?: Maybe<Scalars['DateTime']['output']>;
  ma_type?: Maybe<Array<MaintenanceRepairType>>;
  main_status: Scalars['String']['output'];
  net_amount: Scalars['Float']['output'];
  post_discount_amount: Scalars['Float']['output'];
  pre_discount_amount: Scalars['Float']['output'];
  pre_vat_amount: Scalars['Float']['output'];
  price_vat_type: PriceVatType;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  sub_status: Scalars['String']['output'];
  total_amount: Scalars['Float']['output'];
  trailer_details?: Maybe<Scalars['Json']['output']>;
  trailer_id?: Maybe<Scalars['Int']['output']>;
  type: MaintenanceType;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount: Scalars['Float']['output'];
  vat_7_percent_amount: Scalars['Float']['output'];
  vat_amount: Scalars['Float']['output'];
  vat_exempted_amount: Scalars['Float']['output'];
  vehicle_details: Scalars['Json']['output'];
  vehicle_id?: Maybe<Scalars['Int']['output']>;
  withholding_tax_amount: Scalars['Float']['output'];
};

export type MaintenanceCreateInput = {
  accident_date?: InputMaybe<Scalars['DateTime']['input']>;
  accident_description?: InputMaybe<Scalars['String']['input']>;
  accident_location?: InputMaybe<Scalars['String']['input']>;
  additional_discount: Scalars['Float']['input'];
  additional_discount_type: MaintenanceDiscountType;
  aggrid_status: Scalars['String']['input'];
  attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  claim_attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  claim_no?: InputMaybe<Scalars['String']['input']>;
  created_by: Scalars['Json']['input'];
  driver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_insurance_fully_paid?: InputMaybe<Scalars['Boolean']['input']>;
  issue_date: Scalars['DateTime']['input'];
  ma_details: Scalars['Json']['input'];
  ma_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  ma_item_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  ma_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  ma_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  ma_type?: InputMaybe<Array<MaintenanceRepairType>>;
  main_status: Scalars['String']['input'];
  net_amount: Scalars['Float']['input'];
  post_discount_amount: Scalars['Float']['input'];
  pre_discount_amount: Scalars['Float']['input'];
  pre_vat_amount: Scalars['Float']['input'];
  price_vat_type: PriceVatType;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status: Scalars['String']['input'];
  total_amount: Scalars['Float']['input'];
  trailer_details?: InputMaybe<Scalars['Json']['input']>;
  trailer_id?: InputMaybe<Scalars['Int']['input']>;
  type: MaintenanceType;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount: Scalars['Float']['input'];
  vat_7_percent_amount: Scalars['Float']['input'];
  vat_amount: Scalars['Float']['input'];
  vat_exempted_amount: Scalars['Float']['input'];
  vehicle_details: Scalars['Json']['input'];
  vehicle_id?: InputMaybe<Scalars['Int']['input']>;
  withholding_tax_amount: Scalars['Float']['input'];
};

export enum MaintenanceDiscountType {
  Baht = 'BAHT',
  Percent = 'PERCENT'
}

export type MaintenanceForReference = {
  __typename?: 'MaintenanceForReference';
  id: Scalars['Int']['output'];
  ma_item_list?: Maybe<Array<Scalars['Json']['output']>>;
  unique_id: Scalars['String']['output'];
};

export type MaintenanceItem = {
  __typename?: 'MaintenanceItem';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  indexing: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  item_img_url?: Maybe<Array<Scalars['String']['output']>>;
  item_name: Scalars['String']['output'];
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_unique_id: Scalars['String']['output'];
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  qty_issued?: Maybe<Scalars['Float']['output']>;
  reference_line_item?: Maybe<Scalars['Json']['output']>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  traceability?: Maybe<Traceability>;
  unique_id: Scalars['String']['output'];
  uom_conversion_list?: Maybe<Array<Scalars['Json']['output']>>;
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type MaintenanceItemInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  indexing: Scalars['Int']['input'];
  item_id?: InputMaybe<Scalars['Int']['input']>;
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_unique_id?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  traceability?: InputMaybe<Traceability>;
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  uom_id?: InputMaybe<Scalars['Int']['input']>;
  uom_name?: InputMaybe<Scalars['String']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export enum MaintenanceRepairType {
  Airuu = 'AIRUU',
  AirGenerator_40 = 'AIR_GENERATOR_40',
  Battery = 'BATTERY',
  Brake = 'BRAKE',
  Clutch = 'CLUTCH',
  ElectricalAc = 'ELECTRICAL_AC',
  Engine = 'ENGINE',
  EngineOil = 'ENGINE_OIL',
  GearOil = 'GEAR_OIL',
  GearRear = 'GEAR_REAR',
  Others = 'OTHERS',
  Suspension = 'SUSPENSION',
  TailLift = 'TAIL_LIFT',
  TireWheel = 'TIRE_WHEEL'
}

export type MaintenanceTask = {
  __typename?: 'MaintenanceTask';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  indexing?: Maybe<Scalars['Int']['output']>;
  ma_reference_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MaintenanceTaskInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  indexing?: InputMaybe<Scalars['Int']['input']>;
  ma_reference_id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum MaintenanceType {
  Claim = 'CLAIM',
  DtClaim = 'DT_CLAIM',
  Normal = 'NORMAL'
}

export type MaintenanceUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type MaintenanceUpdateInput = {
  accident_date?: InputMaybe<Scalars['DateTime']['input']>;
  accident_description?: InputMaybe<Scalars['String']['input']>;
  accident_location?: InputMaybe<Scalars['String']['input']>;
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<MaintenanceDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  claim_attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  claim_no?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  driver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_insurance_fully_paid?: InputMaybe<Scalars['Boolean']['input']>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  ma_details?: InputMaybe<Scalars['Json']['input']>;
  ma_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  ma_item_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  ma_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  ma_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  ma_type?: InputMaybe<Array<MaintenanceRepairType>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  trailer_details?: InputMaybe<Scalars['Json']['input']>;
  trailer_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MaintenanceType>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  vehicle_details?: InputMaybe<Scalars['Json']['input']>;
  vehicle_id?: InputMaybe<Scalars['Int']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type MaintenanceView = {
  __typename?: 'MaintenanceView';
  accident_date?: Maybe<Scalars['DateTime']['output']>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  claim_no?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  driver_list?: Maybe<Array<Scalars['String']['output']>>;
  driver_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  garage_name?: Maybe<Scalars['String']['output']>;
  garage_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_insurance_fully_paid?: Maybe<Scalars['Boolean']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  ma_end_date?: Maybe<Scalars['DateTime']['output']>;
  ma_start_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  reference_document_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  trailer_license_plate?: Maybe<Scalars['String']['output']>;
  trailer_no?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MaintenanceType>;
  unique_id?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['Int']['output']>;
  vehicle_license_plate?: Maybe<Scalars['String']['output']>;
  vehicle_no?: Maybe<Scalars['String']['output']>;
};

export type MaintenanceViewAggrid = {
  __typename?: 'MaintenanceViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<MaintenanceView>;
};

export type Mutation = {
  __typename?: 'Mutation';
  BillingNoteCancel: BillingNote;
  BillingNoteCreate: BillingNote;
  BillingNoteUpdate: BillingNote;
  DeliveryTripCreate?: Maybe<DeliveryTrip>;
  DeliveryTripUpdate?: Maybe<DeliveryTrip>;
  /** AC 14/15/17-21 — the write. Per-document transaction; one failure never sinks the batch. */
  ImportDeliveryTripBulk: DeliveryTripBulkImportResult;
  MaintenanceCancel?: Maybe<Maintenance>;
  MaintenanceCreate?: Maybe<Maintenance>;
  MaintenanceUpdate?: Maybe<Maintenance>;
  QuotationCancel: Quotation;
  QuotationCreate: Quotation;
  QuotationUpdate: Quotation;
  TireCreate: CreateTireResult;
  TireRemove?: Maybe<Scalars['String']['output']>;
  TireUpdate: UpdateTireResult;
  VehicleCreate: Vehicle;
  VehicleDelete?: Maybe<Scalars['Boolean']['output']>;
  VehicleUpdate: Vehicle;
};


export type MutationBillingNoteCancelArgs = {
  uniqueInput: BillingNoteUniqueInput;
};


export type MutationBillingNoteCreateArgs = {
  createInput: BillingNoteCreateInput;
};


export type MutationBillingNoteUpdateArgs = {
  uniqueInput: BillingNoteUniqueInput;
  updateInput: BillingNoteUpdateInput;
};


export type MutationDeliveryTripCreateArgs = {
  createInput: DeliveryTripCreateInput;
};


export type MutationDeliveryTripUpdateArgs = {
  uniqueInput: DeliveryUniqueInput;
  updateInput: DeliveryTripUpdateInput;
};


export type MutationImportDeliveryTripBulkArgs = {
  importInput: DeliveryTripBulkImportInput;
};


export type MutationMaintenanceCancelArgs = {
  uniqueInput: MaintenanceUniqueInput;
};


export type MutationMaintenanceCreateArgs = {
  createInput: MaintenanceCreateInput;
};


export type MutationMaintenanceUpdateArgs = {
  uniqueInput: MaintenanceUniqueInput;
  updateInput: MaintenanceUpdateInput;
};


export type MutationQuotationCancelArgs = {
  uniqueInput: QuotationUniqueInput;
};


export type MutationQuotationCreateArgs = {
  createInput: QuotationCreateInput;
};


export type MutationQuotationUpdateArgs = {
  uniqueInput: QuotationUniqueInput;
  updateInput: QuotationUpdateInput;
};


export type MutationTireCreateArgs = {
  createTireInput: CreateTireInput;
};


export type MutationTireRemoveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationTireUpdateArgs = {
  updateTireInput: UpdateTireInput;
};


export type MutationVehicleCreateArgs = {
  createInput: VehicleCreateInput;
};


export type MutationVehicleDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationVehicleUpdateArgs = {
  uniqueInput: VehicleUniqueInput;
  updateInput: VehicleUpdateInput;
};

export enum PriceVatType {
  ExcludedVat = 'excluded_vat',
  IncludedVat = 'included_vat'
}

export enum PurchaseDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseReturn = 'purchase_return'
}

export type PurchaseItemInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  barcode: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_desc?: InputMaybe<Scalars['String']['input']>;
  item_id: Scalars['Int']['input'];
  item_img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  po_qty?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  qty_issued?: InputMaybe<Scalars['Float']['input']>;
  qty_ordered?: InputMaybe<Scalars['Float']['input']>;
  qty_received?: InputMaybe<Scalars['Float']['input']>;
  qty_returned?: InputMaybe<Scalars['Float']['input']>;
  reference_document_type?: InputMaybe<ReferenceDocumentType>;
  reference_line_item?: InputMaybe<Scalars['Json']['input']>;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  rs_qty?: InputMaybe<Scalars['Float']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  traceability: Traceability;
  unique_id: Scalars['String']['input'];
  uom?: InputMaybe<Scalars['Json']['input']>;
  uom_conversion_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  uom_id?: InputMaybe<Scalars['Int']['input']>;
  uom_name?: InputMaybe<Scalars['String']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  wait_receive_qty?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseItemList = {
  __typename?: 'PurchaseItemList';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  barcode: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item_desc?: Maybe<Scalars['String']['output']>;
  item_id: Scalars['Int']['output'];
  item_img_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  item_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  net_amount?: Maybe<Scalars['Float']['output']>;
  po_qty?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_ordered?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  qty_returned?: Maybe<Scalars['Float']['output']>;
  reference_document_type?: Maybe<ReferenceDocumentType>;
  reference_line_item?: Maybe<Scalars['Json']['output']>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  rs_qty?: Maybe<Scalars['Float']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  traceability?: Maybe<Traceability>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['Json']['output']>;
  uom_conversion_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  wait_receive_qty?: Maybe<Scalars['Float']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  BillingNoteByCustomerReportViewsAggrid: BillingNoteByCustomerReportViewAggridOutput;
  BillingNoteByDeliveryItemReportViewsAggrid: BillingNoteByDeliveryItemReportViewAggridOutput;
  BillingNoteByItemReportViewsAggrid: BillingNoteByItemReportViewAggridOutput;
  BillingNoteFindUnique: BillingNote;
  BillingNoteViewsAggrid: BillingNoteViewsAggrid;
  BillingNotesFindAll?: Maybe<Array<BillingNote>>;
  DeliveryReportViewsAggrid: DeliveryReportViewAggridOutput;
  /** AC 1/4/5/7/8/10 — the data plus the column contract. */
  DeliveryTripBulkFetch: DeliveryTripBulkFetchResult;
  /** AC 3 — counts for the fetch dialog, before anyone commits to a pull. */
  DeliveryTripBulkFetchPreview: DeliveryTripBulkPreview;
  /** Creatable/master values backing the sheet's DataValidation ranges. */
  DeliveryTripBulkMasters: DeliveryTripBulkMasterResult;
  DeliveryTripExpensesReportViewsAggrid: DeliveryTripExpensesReportViewAggridOutput;
  DeliveryTripFindAll?: Maybe<Array<DeliveryTrip>>;
  DeliveryTripFindUnique?: Maybe<DeliveryTrip>;
  DeliveryTripForBillingNoteViewAggrid: DeliveryTripForBillingNoteViewAggrid;
  DeliveryTripIncomeReportViewsAggrid: DeliveryTripIncomeReportViewAggridOutput;
  DeliveryTripItemListViewsAggrid: DeliveryTripItemListViewsAggrid;
  DeliveryTripViewAggrid: DeliveryTripViewAggrid;
  DeliveryTripWorkReportViewsAggrid: DeliveryTripWorkReportViewAggridOutput;
  ExpensesListFindMany?: Maybe<Array<ExpensesList>>;
  GenerateBillingNoteReport: Scalars['String']['output'];
  GenerateDeliveryReport: Scalars['String']['output'];
  GenerateMaintenanceExport?: Maybe<Scalars['String']['output']>;
  GenerateQuotationReport: Scalars['String']['output'];
  IncomeListFindMany?: Maybe<Array<IncomeList>>;
  MaintenanceFindAll?: Maybe<Array<Maintenance>>;
  MaintenanceFindUnique?: Maybe<Maintenance>;
  MaintenanceForReferences?: Maybe<Array<MaintenanceForReference>>;
  MaintenanceViewAggrid: MaintenanceViewAggrid;
  QuotationFindUnique: Quotation;
  QuotationReportViewsAggrid: QuotationReportViewAggridOutput;
  QuotationViewsAggrid: QuotationViewsAggrid;
  QuotationsFindAll?: Maybe<Array<Quotation>>;
  TireFindViewAggrid: CustomTire;
  TireFineUnique?: Maybe<Tire>;
  TireUsageGenerateExport: Scalars['String']['output'];
  TireUsageHistoryFindViewAggrid: CustomTireUsageHistory;
  UniqueIdGenerate: Scalars['String']['output'];
  UniqueIdIsExist: Scalars['Boolean']['output'];
  /** AC 11-13 — server-side pre-flight. Writes nothing. */
  ValidateDeliveryTripBulkImport: DeliveryTripBulkValidateResult;
  VehicleFindAll: Array<Maybe<Vehicle>>;
  VehicleFindUnique?: Maybe<Vehicle>;
  VehicleFindViewAggrid: CustomVehicle;
  VehicleGanttChart?: Maybe<Array<Maybe<GanttChartVehicleResponse>>>;
  VehicleGenerateExport: Scalars['String']['output'];
  VehicleValidateInactivate?: Maybe<Scalars['Boolean']['output']>;
  WorkListFindMany?: Maybe<Array<WorkList>>;
};


export type QueryBillingNoteByCustomerReportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryBillingNoteByDeliveryItemReportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryBillingNoteByItemReportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryBillingNoteFindUniqueArgs = {
  uniqueInput: BillingNoteUniqueInput;
};


export type QueryBillingNoteViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryDeliveryReportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryDeliveryTripBulkFetchArgs = {
  filter: DeliveryTripBulkFilterInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDeliveryTripBulkFetchPreviewArgs = {
  filter: DeliveryTripBulkFilterInput;
};


export type QueryDeliveryTripExpensesReportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryDeliveryTripFindUniqueArgs = {
  uniqueInput: DeliveryUniqueInput;
};


export type QueryDeliveryTripForBillingNoteViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryDeliveryTripIncomeReportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryDeliveryTripItemListViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryDeliveryTripViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryDeliveryTripWorkReportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryExpensesListFindManyArgs = {
  input?: InputMaybe<ExpensesListFindManyInput>;
};


export type QueryGenerateBillingNoteReportArgs = {
  input?: InputMaybe<BillingNoteReportGenerateInput>;
};


export type QueryGenerateDeliveryReportArgs = {
  input?: InputMaybe<DeliveryReportGenerateInput>;
};


export type QueryGenerateMaintenanceExportArgs = {
  exportInput?: InputMaybe<GeneralExportInput>;
};


export type QueryGenerateQuotationReportArgs = {
  input?: InputMaybe<QuotationReportGenerateInput>;
};


export type QueryIncomeListFindManyArgs = {
  input?: InputMaybe<IncomeListFindManyInput>;
};


export type QueryMaintenanceFindUniqueArgs = {
  uniqueInput: MaintenanceUniqueInput;
};


export type QueryMaintenanceViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryQuotationFindUniqueArgs = {
  uniqueInput: QuotationUniqueInput;
};


export type QueryQuotationReportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryQuotationViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryTireFindViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryTireFineUniqueArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTireUsageGenerateExportArgs = {
  input?: InputMaybe<TireUsageGenerateExportInput>;
};


export type QueryTireUsageHistoryFindViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryUniqueIdGenerateArgs = {
  issueDate?: InputMaybe<Scalars['String']['input']>;
  modelType: SalesModelType;
};


export type QueryUniqueIdIsExistArgs = {
  modelType: SalesModelType;
  uniqueId: Scalars['String']['input'];
};


export type QueryValidateDeliveryTripBulkImportArgs = {
  importInput: DeliveryTripBulkImportInput;
};


export type QueryVehicleFindUniqueArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVehicleFindViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryVehicleGanttChartArgs = {
  ganttChartFilterInput?: InputMaybe<VehicleGanttChartFilterInput>;
};


export type QueryVehicleGenerateExportArgs = {
  input?: InputMaybe<VehicleGenerateExportInput>;
};


export type QueryVehicleValidateInactivateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWorkListFindManyArgs = {
  input?: InputMaybe<WorkListFindManyInput>;
};

export type Quotation = {
  __typename?: 'Quotation';
  accepted_date?: Maybe<Scalars['DateTime']['output']>;
  accepted_remark?: Maybe<Scalars['String']['output']>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  attachment_list: Array<AttachmentObject>;
  contact_unique_id: Scalars['String']['output'];
  container_type?: Maybe<Scalars['String']['output']>;
  created_by: CreatorObject;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  customer_details: SalesCustomerObject;
  due_date: Scalars['DateTime']['output'];
  expected_temperature?: Maybe<Scalars['String']['output']>;
  flag_status: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_frozen: Scalars['Boolean']['output'];
  issue_date: Scalars['DateTime']['output'];
  item_list: Array<SalesItem>;
  item_type: Scalars['String']['output'];
  item_unique_id_list: Array<Scalars['String']['output']>;
  item_value: Scalars['String']['output'];
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date: Scalars['DateTime']['output'];
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  packing_location: Scalars['String']['output'];
  plan_end_date?: Maybe<Scalars['DateTime']['output']>;
  plan_start_date?: Maybe<Scalars['DateTime']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  related_user_list: Array<CreatorObject>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  vehicle_type: Scalars['String']['output'];
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type QuotationCreateInput = {
  accepted_date?: InputMaybe<Scalars['DateTime']['input']>;
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  attachment_list?: InputMaybe<Array<AttachmentInputObject>>;
  contact_unique_id: Scalars['String']['input'];
  container_type?: InputMaybe<Scalars['String']['input']>;
  created_by: CreatorInputObject;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  customer_details?: InputMaybe<SalesCustomerInputObject>;
  due_date: Scalars['DateTime']['input'];
  expected_temperature?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_frozen: Scalars['Boolean']['input'];
  issue_date: Scalars['DateTime']['input'];
  item_list?: InputMaybe<Array<SalesItemCreateInput>>;
  item_type: Scalars['String']['input'];
  item_value: Scalars['String']['input'];
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  packing_location: Scalars['String']['input'];
  plan_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  plan_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  related_user_list?: InputMaybe<Array<CreatorInputObject>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  vehicle_type: Scalars['String']['input'];
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type QuotationReportGenerateInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  params?: InputMaybe<Scalars['Json']['input']>;
  report_type: QuotationReportType;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum QuotationReportType {
  Quotation = 'quotation'
}

export type QuotationReportView = {
  __typename?: 'QuotationReportView';
  billing_address?: Maybe<Scalars['String']['output']>;
  billing_country?: Maybe<Scalars['String']['output']>;
  billing_district?: Maybe<Scalars['String']['output']>;
  billing_postal_code?: Maybe<Scalars['String']['output']>;
  billing_province?: Maybe<Scalars['String']['output']>;
  billing_sub_district?: Maybe<Scalars['String']['output']>;
  container_type?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_identity_no?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  is_frozen?: Maybe<Scalars['Boolean']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  item_value?: Maybe<Scalars['String']['output']>;
  item_withholding_tax_value?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  packing_location?: Maybe<Scalars['String']['output']>;
  plan_end_date?: Maybe<Scalars['DateTime']['output']>;
  plan_start_date?: Maybe<Scalars['DateTime']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  related_user_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type QuotationReportViewAggridOutput = {
  __typename?: 'QuotationReportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<QuotationReportView>;
};

export type QuotationUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type QuotationUpdateInput = {
  accepted_date?: InputMaybe<Scalars['DateTime']['input']>;
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  attachment_list?: InputMaybe<Array<AttachmentInputObject>>;
  contact_unique_id: Scalars['String']['input'];
  container_type?: InputMaybe<Scalars['String']['input']>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  customer_details?: InputMaybe<SalesCustomerInputObject>;
  due_date: Scalars['DateTime']['input'];
  expected_temperature?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_frozen: Scalars['Boolean']['input'];
  issue_date: Scalars['DateTime']['input'];
  item_list?: InputMaybe<Array<SalesItemUpsertInput>>;
  item_type: Scalars['String']['input'];
  item_value: Scalars['String']['input'];
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  packing_location: Scalars['String']['input'];
  plan_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  plan_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  related_user_list?: InputMaybe<Array<CreatorInputObject>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  vehicle_type: Scalars['String']['input'];
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type QuotationView = {
  __typename?: 'QuotationView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<CreatorObject>;
  customer_name?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<CreatorObject>>;
  unique_id: Scalars['String']['output'];
};

export type QuotationViewsAggrid = {
  __typename?: 'QuotationViewsAggrid';
  count: Scalars['Int']['output'];
  results: Array<QuotationView>;
};

export type ReferenceDocumentList = {
  __typename?: 'ReferenceDocumentList';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<PurchaseDocumentType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ReferenceDocumentListInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<PurchaseDocumentType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum ReferenceDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseReturn = 'purchase_return'
}

export type RelatedUser = {
  __typename?: 'RelatedUser';
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  title_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type RelatedUserList = {
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  title_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ReportResult = {
  __typename?: 'ReportResult';
  detail?: Maybe<Scalars['Json']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type SalesCustomerInputObject = {
  billing_address?: InputMaybe<AddressInputObject>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  identity_no?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SalesCustomerObject = {
  __typename?: 'SalesCustomerObject';
  billing_address?: Maybe<AddressObject>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  identity_no?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SalesItem = {
  __typename?: 'SalesItem';
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_id: Scalars['Int']['output'];
  item_img_url: Array<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_unique_id: Scalars['String']['output'];
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  stock_qty?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  uom_conversion_list?: Maybe<Array<Scalars['Json']['output']>>;
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type SalesItemCreateInput = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  item_id: Scalars['Int']['input'];
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_unique_id: Scalars['String']['input'];
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  stock_qty?: InputMaybe<Scalars['Float']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  uom_id?: InputMaybe<Scalars['Int']['input']>;
  uom_name?: InputMaybe<Scalars['String']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesItemUpsertInput = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_id: Scalars['Int']['input'];
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_unique_id: Scalars['String']['input'];
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  stock_qty?: InputMaybe<Scalars['Float']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  uom_id?: InputMaybe<Scalars['Int']['input']>;
  uom_name?: InputMaybe<Scalars['String']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export enum SalesModelType {
  BillingNote = 'billing_note',
  DeliveryTrip = 'delivery_trip',
  Maintenance = 'maintenance',
  Quotation = 'quotation'
}

export type SelectOptionById = {
  __typename?: 'SelectOptionById';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpectaQlOption = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  document_type: TagDocumentType;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum TagDocumentType {
  Batch = 'batch',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  Employee = 'employee',
  Event = 'event',
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsTransfer = 'goods_transfer',
  Inventory = 'inventory',
  Item = 'item',
  PaymentMade = 'payment_made',
  PaymentReceive = 'payment_receive',
  Project = 'project',
  Promotion = 'promotion',
  Purchase = 'purchase',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  Sale = 'sale',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Serial = 'serial',
  Task = 'task'
}

export type Task = {
  __typename?: 'Task';
  info?: Maybe<TaskInfo>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TaskInfo = {
  __typename?: 'TaskInfo';
  car_id?: Maybe<Scalars['String']['output']>;
  car_license?: Maybe<Scalars['String']['output']>;
  deliver_1?: Maybe<Scalars['String']['output']>;
  deliver_2?: Maybe<Scalars['String']['output']>;
  document_id?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  job_no?: Maybe<Scalars['String']['output']>;
  reference_document_no?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stop?: Maybe<Scalars['String']['output']>;
  trailer_license_id?: Maybe<Scalars['String']['output']>;
  trailer_unique_id?: Maybe<Scalars['String']['output']>;
};

export type Tire = {
  __typename?: 'Tire';
  band?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['Date']['output'];
  current_distance: Scalars['Int']['output'];
  due_distance: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  last_updated_by: Scalars['Json']['output'];
  last_updated_date: Scalars['Date']['output'];
  model?: Maybe<Scalars['String']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  serial: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum TireActionType {
  Install = 'install',
  Uninstall = 'uninstall'
}

export type TireInput = {
  action_date?: InputMaybe<Scalars['DateTime']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  tire_id: Scalars['Int']['input'];
};

export type TireStatus = {
  __typename?: 'TireStatus';
  approachAmount: Scalars['Int']['output'];
  normalAmount: Scalars['Int']['output'];
  overDueAmount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TireUpdateInput = {
  action_date?: InputMaybe<Scalars['DateTime']['input']>;
  action_type?: InputMaybe<TireActionType>;
  position?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  tire_id: Scalars['Int']['input'];
};

export type TireUpdatePositionInput = {
  change_date?: InputMaybe<Scalars['DateTime']['input']>;
  current_position?: InputMaybe<Scalars['String']['input']>;
  previous_position?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  tire_id: Scalars['Int']['input'];
};

export type TireUsageGenerateExportInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TireUsageHistoryView = {
  __typename?: 'TireUsageHistoryView';
  action_date: Scalars['DateTime']['output'];
  action_distance: Scalars['Float']['output'];
  action_type: Scalars['String']['output'];
  band?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['DateTime']['output'];
  current_position?: Maybe<Scalars['String']['output']>;
  due_distance: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  last_updated_date: Scalars['DateTime']['output'];
  model?: Maybe<Scalars['String']['output']>;
  previous_position?: Maybe<Scalars['String']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  tire_distance: Scalars['Float']['output'];
  tire_id: Scalars['Int']['output'];
  tire_notification_status: Scalars['String']['output'];
  tire_series: Scalars['String']['output'];
  tire_status: Scalars['String']['output'];
  usage_distance: Scalars['Float']['output'];
  vehicle_license: Scalars['String']['output'];
  vehicle_type: Scalars['String']['output'];
  vehicle_unique_id: Scalars['String']['output'];
};

export type TireView = {
  __typename?: 'TireView';
  band?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['Date']['output'];
  current_distance: Scalars['Int']['output'];
  due_distance: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  last_updated_by: Scalars['Json']['output'];
  last_updated_date: Scalars['Date']['output'];
  maintenance_status: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  serial: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum Traceability {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export type Trailer = {
  __typename?: 'Trailer';
  act_end_date?: Maybe<Scalars['DateTime']['output']>;
  act_id?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  current_kilometer?: Maybe<Scalars['Decimal']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Array<Maybe<VehicleDriver>>>;
  due_distance_kilometer?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  register_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<VehicleStatus>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['Json']['output']>;
};

export type UpdateTireInput = {
  band?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  due_distance?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_updated_by: CreatorInputObject;
  model?: InputMaybe<Scalars['String']['input']>;
  price_per_unit?: InputMaybe<Scalars['Decimal']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTireResult = {
  __typename?: 'UpdateTireResult';
  band?: Maybe<Scalars['String']['output']>;
  created_by: CreatorObject;
  created_date: Scalars['DateTime']['output'];
  current_distance: Scalars['Int']['output'];
  due_distance: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  last_updated_by: CreatorObject;
  last_updated_date: Scalars['DateTime']['output'];
  model?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  serial: Scalars['String']['output'];
  status: Scalars['String']['output'];
  vehicle_id?: Maybe<Scalars['String']['output']>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  act_end_date?: Maybe<Scalars['DateTime']['output']>;
  act_id?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  current_kilometer?: Maybe<Scalars['Decimal']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Array<Maybe<VehicleDriver>>>;
  due_distance_kilometer?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Array<Maybe<VehicleImage>>>;
  insurance_product?: Maybe<InsuranceDetail>;
  insurance_vehicle?: Maybe<InsuranceDetail>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_tire?: Maybe<Array<Maybe<VehicleTire>>>;
  model?: Maybe<Scalars['String']['output']>;
  register_id?: Maybe<Scalars['String']['output']>;
  spare_tire?: Maybe<Array<Maybe<VehicleTire>>>;
  status?: Maybe<VehicleStatus>;
  status_note?: Maybe<Scalars['String']['output']>;
  tire_status?: Maybe<TireStatus>;
  trailer?: Maybe<Trailer>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type VehicleCreateInput = {
  act_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  act_id?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  created_by: CreateVehicleByInput;
  current_kilometer: Scalars['Decimal']['input'];
  detail?: InputMaybe<Scalars['String']['input']>;
  driver?: InputMaybe<Array<InputMaybe<CreateVehicleDriverInput>>>;
  due_distance_kilometer: Scalars['Decimal']['input'];
  image?: InputMaybe<Array<InputMaybe<CreateVehicleImageInput>>>;
  insurance_product?: InputMaybe<CreateInsuranceInput>;
  insurance_vehicle?: InputMaybe<CreateInsuranceInput>;
  model?: InputMaybe<Scalars['String']['input']>;
  register_id: Scalars['String']['input'];
  status: VehicleStatus;
  status_note?: InputMaybe<Scalars['String']['input']>;
  tire?: InputMaybe<Array<InputMaybe<TireInput>>>;
  type: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
  vehicle_id?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleDriver = {
  __typename?: 'VehicleDriver';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type VehicleDriverUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleGanttChartFilterInput = {
  date: Scalars['DateTime']['input'];
  license_plate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GanttChartVehicleStatus>;
  vehicle_type: Scalars['String']['input'];
};

export type VehicleGenerateExportInput = {
  vehicle_type: VehicleTypeInput;
};

export type VehicleImage = {
  __typename?: 'VehicleImage';
  file_path?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_primary?: Maybe<Scalars['Boolean']['output']>;
};

export type VehicleImageUpdateInput = {
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VehicleStatus {
  Active = 'active',
  Draft = 'draft',
  InActive = 'in_active'
}

export type VehicleTire = {
  __typename?: 'VehicleTire';
  band?: Maybe<Scalars['String']['output']>;
  current_distance: Scalars['Float']['output'];
  due_distance: Scalars['Float']['output'];
  model?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  serial: Scalars['String']['output'];
  tire_id: Scalars['Int']['output'];
};

export enum VehicleTypeInput {
  AllVehicle = 'all_vehicle',
  Approaching = 'approaching',
  Default = 'default',
  FourWheels = 'four_wheels',
  Head = 'head',
  Overdue = 'overdue',
  SixWheels = 'six_wheels',
  TenWheels = 'ten_wheels',
  Trailers = 'trailers'
}

export type VehicleUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleUpdateInput = {
  act_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  act_id?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  current_kilometer?: InputMaybe<Scalars['Decimal']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  driver?: InputMaybe<Array<InputMaybe<VehicleDriverUpdateInput>>>;
  due_distance_kilometer?: InputMaybe<Scalars['Decimal']['input']>;
  image?: InputMaybe<Array<InputMaybe<VehicleImageUpdateInput>>>;
  insurance_product?: InputMaybe<InsuranceUpdateInput>;
  insurance_vehicle?: InputMaybe<InsuranceUpdateInput>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  register_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VehicleStatus>;
  status_note?: InputMaybe<Scalars['String']['input']>;
  tire?: InputMaybe<Array<InputMaybe<TireUpdateInput>>>;
  tire_position?: InputMaybe<Array<InputMaybe<TireUpdatePositionInput>>>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleView = {
  __typename?: 'VehicleView';
  act_end_date?: Maybe<Scalars['DateTime']['output']>;
  act_id?: Maybe<Scalars['String']['output']>;
  act_status?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  current_kilometer?: Maybe<Scalars['Decimal']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  driver_object_list?: Maybe<Array<Maybe<VehicleDriver>>>;
  due_distance_kilometer?: Maybe<Scalars['Decimal']['output']>;
  has_approaching?: Maybe<Scalars['Int']['output']>;
  has_overdue?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insurance_product_end_date?: Maybe<Scalars['DateTime']['output']>;
  insurance_product_policy_id?: Maybe<Scalars['String']['output']>;
  insurance_product_protection_value?: Maybe<Scalars['Float']['output']>;
  insurance_product_start_date?: Maybe<Scalars['DateTime']['output']>;
  insurance_product_status?: Maybe<Scalars['String']['output']>;
  insurance_product_tier?: Maybe<Scalars['String']['output']>;
  insurance_vehicle_end_date?: Maybe<Scalars['DateTime']['output']>;
  insurance_vehicle_policy_id?: Maybe<Scalars['String']['output']>;
  insurance_vehicle_protection_value?: Maybe<Scalars['Float']['output']>;
  insurance_vehicle_start_date?: Maybe<Scalars['DateTime']['output']>;
  insurance_vehicle_status?: Maybe<Scalars['String']['output']>;
  insurance_vehicle_tier?: Maybe<Scalars['String']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  maintenance_status?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  register_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<VehicleStatus>;
  status_note?: Maybe<Scalars['String']['output']>;
  tire_maintenance_status?: Maybe<Scalars['String']['output']>;
  trailer_id?: Maybe<Scalars['Int']['output']>;
  trailer_register_id?: Maybe<Scalars['String']['output']>;
  trailer_unique_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  warehouse_level_1_list?: Maybe<Array<WarehouseLevel1>>;
};

export type WarehouseLevel1 = {
  __typename?: 'WarehouseLevel1';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouse_level_2_list?: Maybe<Array<WarehouseLevel2>>;
};

export type WarehouseLevel2 = {
  __typename?: 'WarehouseLevel2';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_1: WarehouseLevel1;
  warehouse_level_3_list?: Maybe<Array<WarehouseLevel3>>;
};

export type WarehouseLevel3 = {
  __typename?: 'WarehouseLevel3';
  bin_location_list?: Maybe<Array<BinLocation>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_2: WarehouseLevel2;
};

export type WorkList = {
  __typename?: 'WorkList';
  arrived_kilometer?: Maybe<Scalars['Float']['output']>;
  coordinator_name: Scalars['String']['output'];
  coordinator_phone: Scalars['String']['output'];
  customer_name: Scalars['String']['output'];
  distance: Scalars['Float']['output'];
  drop_cost?: Maybe<Scalars['Float']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  location_name: Scalars['String']['output'];
  location_unique_id: Scalars['String']['output'];
  max_shipping_cost: Scalars['Float']['output'];
  reference_code?: Maybe<Scalars['String']['output']>;
  reference_unique_id: Scalars['String']['output'];
  seal_no?: Maybe<Scalars['String']['output']>;
  secondary_driver_cost?: Maybe<Scalars['Float']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  special_request?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
};

export type WorkListCreateInput = {
  arrived_kilometer?: InputMaybe<Scalars['Float']['input']>;
  coordinator_name: Scalars['String']['input'];
  coordinator_phone: Scalars['String']['input'];
  customer_name: Scalars['String']['input'];
  distance: Scalars['Float']['input'];
  drop_cost?: InputMaybe<Scalars['Float']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  index: Scalars['Int']['input'];
  location_name: Scalars['String']['input'];
  location_unique_id: Scalars['String']['input'];
  max_shipping_cost: Scalars['Float']['input'];
  reference_code?: InputMaybe<Scalars['String']['input']>;
  reference_unique_id: Scalars['String']['input'];
  seal_no?: InputMaybe<Scalars['String']['input']>;
  secondary_driver_cost?: InputMaybe<Scalars['Float']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  special_request?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  type: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
};

export type WorkListFindManyInput = {
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type WorkListUpsertInput = {
  arrived_kilometer?: InputMaybe<Scalars['Float']['input']>;
  coordinator_name: Scalars['String']['input'];
  coordinator_phone: Scalars['String']['input'];
  customer_name: Scalars['String']['input'];
  distance: Scalars['Float']['input'];
  drop_cost?: InputMaybe<Scalars['Float']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  index: Scalars['Int']['input'];
  location_name: Scalars['String']['input'];
  location_unique_id: Scalars['String']['input'];
  max_shipping_cost: Scalars['Float']['input'];
  reference_code?: InputMaybe<Scalars['String']['input']>;
  reference_unique_id: Scalars['String']['input'];
  seal_no?: InputMaybe<Scalars['String']['input']>;
  secondary_driver_cost?: InputMaybe<Scalars['Float']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  special_request?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  type: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
};

export type DeliveryTripCreateMutationVariables = Exact<{
  createInput: DeliveryTripCreateInput;
}>;


export type DeliveryTripCreateMutation = { __typename?: 'Mutation', DeliveryTripCreate?: { __typename?: 'DeliveryTrip', id: number, unique_id: string, job_no: string, created_date: any, created_by: any, last_updated_date?: any | null, last_updated_by?: any | null, related_user_list: Array<any>, issue_date: any, vehicle_id: number, vehicle: any, trailer_id?: number | null, trailer?: any | null, primary_driver: any, secondary_driver?: any | null, customer_unique_id: string, customer_details: any, container_type?: string | null, item_type?: string | null, item_amount?: string | null, is_frozen?: boolean | null, temperature_type?: string | null, packaging_location?: string | null, expected_temperature?: string | null, plan_start_date?: any | null, plan_end_date?: any | null, actual_start_date?: any | null, actual_end_date?: any | null, start_kilometer?: number | null, end_kilometer?: number | null, total_kilometer_distance?: number | null, route_code?: string | null, plan_distance?: number | null, fuel_price?: number | null, temperature_start_hours?: number | null, temperature_end_hours?: number | null, total_temperature_hours?: number | null, fuel?: any | null, work_total_amount: number, max_shipping_cost: number, secondary_driver_cost: number, drop_cost: number, income_post_discount_amount: number, income_vat_exempted_amount: number, income_vat_0_percent_amount: number, income_vat_7_percent_amount: number, income_vat_amount: number, income_net_amount: number, income_withholding_tax_amount: number, income_total_amount: number, expenses_post_discount_amount: number, expenses_vat_exempted_amount: number, expenses_vat_0_percent_amount: number, expenses_vat_7_percent_amount: number, expenses_vat_amount: number, expenses_net_amount: number, expenses_withholding_tax_amount: number, expenses_total_amount: number, main_status: string, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, attachment_list?: Array<any> | null, remark?: string | null, reference_document_list?: Array<any> | null, work_list?: Array<{ __typename?: 'WorkList', id: number, index: number, unique_id: string, location_unique_id: string, location_name: string, type: string, special_request?: string | null, customer_name: string, coordinator_name: string, coordinator_phone: string, reference_code?: string | null, seal_no?: string | null, distance: number, shipping_cost?: number | null, secondary_driver_cost?: number | null, drop_cost?: number | null, max_shipping_cost: number, start_date?: any | null, end_date?: any | null, arrived_kilometer?: number | null, reference_unique_id: string }> | null, income_list?: Array<{ __typename?: 'IncomeList', id: number, index: number, unique_id: string, item_id: number, item_unique_id: string, item_name: string, item_sku_desc?: string | null, qty?: number | null, uom_id: number, uom_name: string, uom_conversion_list?: Array<any> | null, price_per_unit: number, discount: number, vat_percentage: string, pre_vat_amount: number, withholding_tax_type?: string | null, withholding_tax_value?: number | null, reference_unique_id: string }> | null, expenses_list?: Array<{ __typename?: 'ExpensesList', id: number, index: number, unique_id: string, item_id: number, item_unique_id: string, item_name: string, item_sku_desc?: string | null, qty?: number | null, uom_id: number, uom_name: string, uom_conversion_list?: Array<any> | null, price_per_unit: number, discount: number, vat_percentage: string, pre_vat_amount: number, withholding_tax_type?: string | null, withholding_tax_value?: number | null, reference_unique_id: string, driver_no?: DriverNo | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null }> | null } | null };

export type DeliveryTripFindUniqueQueryVariables = Exact<{
  uniqueInput: DeliveryUniqueInput;
}>;


export type DeliveryTripFindUniqueQuery = { __typename?: 'Query', DeliveryTripFindUnique?: { __typename?: 'DeliveryTrip', id: number, unique_id: string, job_no: string, created_date: any, created_by: any, last_updated_date?: any | null, last_updated_by?: any | null, related_user_list: Array<any>, issue_date: any, vehicle_id: number, vehicle: any, trailer_id?: number | null, trailer?: any | null, primary_driver: any, secondary_driver?: any | null, customer_unique_id: string, customer_details: any, container_type?: string | null, item_type?: string | null, item_amount?: string | null, is_frozen?: boolean | null, temperature_type?: string | null, packaging_location?: string | null, expected_temperature?: string | null, plan_start_date?: any | null, plan_end_date?: any | null, actual_start_date?: any | null, actual_end_date?: any | null, start_kilometer?: number | null, end_kilometer?: number | null, total_kilometer_distance?: number | null, route_code?: string | null, plan_distance?: number | null, fuel_price?: number | null, temperature_start_hours?: number | null, temperature_end_hours?: number | null, total_temperature_hours?: number | null, fuel?: any | null, work_total_amount: number, max_shipping_cost: number, secondary_driver_cost: number, drop_cost: number, income_post_discount_amount: number, income_vat_exempted_amount: number, income_vat_0_percent_amount: number, income_vat_7_percent_amount: number, income_vat_amount: number, income_net_amount: number, income_withholding_tax_amount: number, income_total_amount: number, expenses_post_discount_amount: number, expenses_vat_exempted_amount: number, expenses_vat_0_percent_amount: number, expenses_vat_7_percent_amount: number, expenses_vat_amount: number, expenses_net_amount: number, expenses_withholding_tax_amount: number, expenses_total_amount: number, main_status: string, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, attachment_list?: Array<any> | null, remark?: string | null, reference_document_list?: Array<any> | null, payment_date?: any | null, payment_detail?: string | null, payment_status?: boolean | null, created_payment_date?: any | null, work_list?: Array<{ __typename?: 'WorkList', id: number, index: number, unique_id: string, location_unique_id: string, location_name: string, type: string, special_request?: string | null, customer_name: string, coordinator_name: string, coordinator_phone: string, reference_code?: string | null, seal_no?: string | null, distance: number, shipping_cost?: number | null, secondary_driver_cost?: number | null, drop_cost?: number | null, max_shipping_cost: number, start_date?: any | null, end_date?: any | null, arrived_kilometer?: number | null, reference_unique_id: string }> | null, income_list?: Array<{ __typename?: 'IncomeList', id: number, index: number, unique_id: string, item_id: number, item_unique_id: string, item_name: string, item_sku_desc?: string | null, qty?: number | null, uom_id: number, uom_name: string, uom_conversion_list?: Array<any> | null, price_per_unit: number, discount: number, vat_percentage: string, pre_vat_amount: number, withholding_tax_type?: string | null, withholding_tax_value?: number | null, reference_unique_id: string }> | null, expenses_list?: Array<{ __typename?: 'ExpensesList', id: number, index: number, unique_id: string, item_id: number, item_unique_id: string, item_name: string, item_sku_desc?: string | null, qty?: number | null, uom_id: number, uom_name: string, uom_conversion_list?: Array<any> | null, price_per_unit: number, discount: number, vat_percentage: string, pre_vat_amount: number, withholding_tax_type?: string | null, withholding_tax_value?: number | null, reference_unique_id: string, driver_no?: DriverNo | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null }> | null } | null };

export type DeliveryTripUpdateMutationVariables = Exact<{
  uniqueInput: DeliveryUniqueInput;
  updateInput: DeliveryTripUpdateInput;
}>;


export type DeliveryTripUpdateMutation = { __typename?: 'Mutation', DeliveryTripUpdate?: { __typename?: 'DeliveryTrip', id: number, unique_id: string, job_no: string, created_date: any, created_by: any, last_updated_date?: any | null, last_updated_by?: any | null, related_user_list: Array<any>, issue_date: any, vehicle_id: number, vehicle: any, trailer_id?: number | null, trailer?: any | null, primary_driver: any, secondary_driver?: any | null, customer_unique_id: string, customer_details: any, container_type?: string | null, item_type?: string | null, item_amount?: string | null, is_frozen?: boolean | null, temperature_type?: string | null, packaging_location?: string | null, expected_temperature?: string | null, plan_start_date?: any | null, plan_end_date?: any | null, actual_start_date?: any | null, actual_end_date?: any | null, start_kilometer?: number | null, end_kilometer?: number | null, total_kilometer_distance?: number | null, route_code?: string | null, plan_distance?: number | null, fuel_price?: number | null, temperature_start_hours?: number | null, temperature_end_hours?: number | null, total_temperature_hours?: number | null, fuel?: any | null, work_total_amount: number, max_shipping_cost: number, secondary_driver_cost: number, drop_cost: number, income_post_discount_amount: number, income_vat_exempted_amount: number, income_vat_0_percent_amount: number, income_vat_7_percent_amount: number, income_vat_amount: number, income_net_amount: number, income_withholding_tax_amount: number, income_total_amount: number, expenses_post_discount_amount: number, expenses_vat_exempted_amount: number, expenses_vat_0_percent_amount: number, expenses_vat_7_percent_amount: number, expenses_vat_amount: number, expenses_net_amount: number, expenses_withholding_tax_amount: number, expenses_total_amount: number, main_status: string, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, attachment_list?: Array<any> | null, remark?: string | null, reference_document_list?: Array<any> | null, payment_date?: any | null, payment_detail?: string | null, payment_status?: boolean | null, created_payment_date?: any | null, work_list?: Array<{ __typename?: 'WorkList', id: number, index: number, unique_id: string, location_unique_id: string, location_name: string, type: string, special_request?: string | null, customer_name: string, coordinator_name: string, coordinator_phone: string, reference_code?: string | null, seal_no?: string | null, distance: number, shipping_cost?: number | null, secondary_driver_cost?: number | null, drop_cost?: number | null, max_shipping_cost: number, start_date?: any | null, end_date?: any | null, arrived_kilometer?: number | null, reference_unique_id: string }> | null, income_list?: Array<{ __typename?: 'IncomeList', id: number, index: number, unique_id: string, item_id: number, item_unique_id: string, item_name: string, item_sku_desc?: string | null, qty?: number | null, uom_id: number, uom_name: string, uom_conversion_list?: Array<any> | null, price_per_unit: number, discount: number, vat_percentage: string, pre_vat_amount: number, withholding_tax_type?: string | null, withholding_tax_value?: number | null, reference_unique_id: string }> | null, expenses_list?: Array<{ __typename?: 'ExpensesList', id: number, index: number, unique_id: string, item_id: number, item_unique_id: string, item_name: string, item_sku_desc?: string | null, qty?: number | null, uom_id: number, uom_name: string, uom_conversion_list?: Array<any> | null, price_per_unit: number, discount: number, vat_percentage: string, pre_vat_amount: number, withholding_tax_type?: string | null, withholding_tax_value?: number | null, reference_unique_id: string, driver_no?: DriverNo | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null }> | null } | null };

export type SalesUniqueIdGenerateQueryVariables = Exact<{
  modelType: SalesModelType;
  issueDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesUniqueIdGenerateQuery = { __typename?: 'Query', UniqueIdGenerate: string };

export type TireCreateMutationVariables = Exact<{
  createTireInput: CreateTireInput;
}>;


export type TireCreateMutation = { __typename?: 'Mutation', TireCreate: { __typename?: 'CreateTireResult', id: string, serial: string, model?: string | null, band?: string | null, current_distance: number, due_distance: number, price_per_unit?: number | null, status: string, position?: string | null, remark?: string | null, vehicle_id?: string | null, created_date: any, last_updated_date: any, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } } };

export type TireUsageGenerateExportQueryVariables = Exact<{
  input?: InputMaybe<TireUsageGenerateExportInput>;
}>;


export type TireUsageGenerateExportQuery = { __typename?: 'Query', TireUsageGenerateExport: string };

export type TireFineUniqueQueryVariables = Exact<{
  tireFineUniqueId: Scalars['Int']['input'];
}>;


export type TireFineUniqueQuery = { __typename?: 'Query', TireFineUnique?: { __typename?: 'Tire', id: string, serial: string, model?: string | null, band?: string | null, current_distance: number, due_distance: number, price_per_unit?: number | null, status: string, remark?: string | null, created_date: any, created_by: any, last_updated_date: any, last_updated_by: any, is_active: boolean } | null };

export type TireRemoveMutationVariables = Exact<{
  tireRemoveId: Scalars['Int']['input'];
}>;


export type TireRemoveMutation = { __typename?: 'Mutation', TireRemove?: string | null };

export type TireUpdateMutationVariables = Exact<{
  updateTireInput: UpdateTireInput;
}>;


export type TireUpdateMutation = { __typename?: 'Mutation', TireUpdate: { __typename?: 'UpdateTireResult', id: string, serial: string, model?: string | null, band?: string | null, current_distance: number, due_distance: number, price_per_unit?: number | null, status: string, position?: string | null, remark?: string | null, vehicle_id?: string | null, created_date: any, last_updated_date: any, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } } };

export type BillingNoteCancelMutationVariables = Exact<{
  uniqueInput: BillingNoteUniqueInput;
}>;


export type BillingNoteCancelMutation = { __typename?: 'Mutation', BillingNoteCancel: { __typename?: 'BillingNote', id: number, unique_id: string, created_date: any, last_updated_date: any, issue_date: any, due_date: any, credit_day?: number | null, company_type?: string | null, customer_unique_id: string, pre_discount_amount?: number | null, discount_type?: string | null, discount?: number | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_type?: string | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_percent?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, accepted_date?: any | null, accepted_remark?: string | null, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, related_user_list: Array<{ __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }>, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null }, attachment_list: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }>, item_list?: Array<{ __typename?: 'DeliveryTripList', id: number, unique_id: string, dt_reference_unique_id: string, dt_income_unique_id: string, issue_date: any, dt_income_post_discount_amount: number, income_post_discount_amount: number, income_vat_exempted_amount?: number | null, income_vat_0_percent_amount?: number | null, income_vat_7_percent_amount?: number | null, income_vat_amount?: number | null, income_net_amount?: number | null, dt_income_withholding_tax_amount?: number | null, income_withholding_tax_amount?: number | null, income_total_amount?: number | null, description?: string | null, source_location?: string | null, destination_location?: string | null, vehicle_id: number, vehicle_details?: any | null, aggrid_status?: string | null, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null } }> | null, delivery_trip_item_list?: Array<{ __typename?: 'DeliveryTripItemList', unique_id: string, dt_unique_id: string, dt_job_no?: string | null, dt_issue_date: any, dt_vehicle_id: number, dt_vehicle_license_plate?: string | null, dt_vehicle_type?: string | null, dt_fuel_price?: number | null, income_unique_id: string, income_item_unique_id?: string | null, income_item_name?: string | null, income_item_pre_vat_amount?: number | null, description?: string | null }> | null } };

export type BillingNoteCreateMutationVariables = Exact<{
  createInput: BillingNoteCreateInput;
}>;


export type BillingNoteCreateMutation = { __typename?: 'Mutation', BillingNoteCreate: { __typename?: 'BillingNote', id: number, unique_id: string, created_date: any, last_updated_date: any, issue_date: any, due_date: any, credit_day?: number | null, company_type?: string | null, customer_unique_id: string, pre_discount_amount?: number | null, discount_type?: string | null, discount?: number | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_type?: string | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_percent?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, accepted_date?: any | null, accepted_remark?: string | null, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, related_user_list: Array<{ __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }>, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null }, attachment_list: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }>, item_list?: Array<{ __typename?: 'DeliveryTripList', id: number, unique_id: string, dt_reference_unique_id: string, dt_income_unique_id: string, issue_date: any, dt_income_post_discount_amount: number, income_post_discount_amount: number, income_vat_exempted_amount?: number | null, income_vat_0_percent_amount?: number | null, income_vat_7_percent_amount?: number | null, income_vat_amount?: number | null, income_net_amount?: number | null, dt_income_withholding_tax_amount?: number | null, income_withholding_tax_amount?: number | null, income_total_amount?: number | null, description?: string | null, source_location?: string | null, destination_location?: string | null, vehicle_id: number, vehicle_details?: any | null, aggrid_status?: string | null, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null } }> | null, delivery_trip_item_list?: Array<{ __typename?: 'DeliveryTripItemList', unique_id: string, dt_unique_id: string, dt_job_no?: string | null, dt_issue_date: any, dt_vehicle_id: number, dt_vehicle_license_plate?: string | null, dt_vehicle_type?: string | null, dt_fuel_price?: number | null, income_unique_id: string, income_item_unique_id?: string | null, income_item_name?: string | null, income_item_pre_vat_amount?: number | null, description?: string | null }> | null } };

export type BillingNoteFindUniqueQueryVariables = Exact<{
  uniqueInput: BillingNoteUniqueInput;
}>;


export type BillingNoteFindUniqueQuery = { __typename?: 'Query', BillingNoteFindUnique: { __typename?: 'BillingNote', id: number, unique_id: string, created_date: any, last_updated_date: any, issue_date: any, due_date: any, credit_day?: number | null, company_type?: string | null, customer_unique_id: string, pre_discount_amount?: number | null, discount_type?: string | null, discount?: number | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_type?: string | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_percent?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, accepted_date?: any | null, accepted_remark?: string | null, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, related_user_list: Array<{ __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }>, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null }, attachment_list: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }>, item_list?: Array<{ __typename?: 'DeliveryTripList', id: number, unique_id: string, dt_reference_unique_id: string, dt_income_unique_id: string, issue_date: any, dt_income_post_discount_amount: number, income_post_discount_amount: number, income_vat_exempted_amount?: number | null, income_vat_0_percent_amount?: number | null, income_vat_7_percent_amount?: number | null, income_vat_amount?: number | null, income_net_amount?: number | null, dt_income_withholding_tax_amount?: number | null, income_withholding_tax_amount?: number | null, income_total_amount?: number | null, description?: string | null, source_location?: string | null, destination_location?: string | null, vehicle_id: number, vehicle_details?: any | null, aggrid_status?: string | null, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null } }> | null, delivery_trip_item_list?: Array<{ __typename?: 'DeliveryTripItemList', unique_id: string, dt_unique_id: string, dt_job_no?: string | null, dt_issue_date: any, dt_vehicle_id: number, dt_vehicle_license_plate?: string | null, dt_vehicle_type?: string | null, dt_fuel_price?: number | null, income_unique_id: string, income_item_unique_id?: string | null, income_item_name?: string | null, income_item_pre_vat_amount?: number | null, description?: string | null }> | null } };

export type BillingNoteUpdateMutationVariables = Exact<{
  uniqueInput: BillingNoteUniqueInput;
  updateInput: BillingNoteUpdateInput;
}>;


export type BillingNoteUpdateMutation = { __typename?: 'Mutation', BillingNoteUpdate: { __typename?: 'BillingNote', id: number, unique_id: string, created_date: any, last_updated_date: any, issue_date: any, due_date: any, credit_day?: number | null, company_type?: string | null, customer_unique_id: string, pre_discount_amount?: number | null, discount_type?: string | null, discount?: number | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_type?: string | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_percent?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, accepted_date?: any | null, accepted_remark?: string | null, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, related_user_list: Array<{ __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }>, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null }, attachment_list: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }>, item_list?: Array<{ __typename?: 'DeliveryTripList', id: number, unique_id: string, dt_reference_unique_id: string, dt_income_unique_id: string, issue_date: any, dt_income_post_discount_amount: number, income_post_discount_amount: number, income_vat_exempted_amount?: number | null, income_vat_0_percent_amount?: number | null, income_vat_7_percent_amount?: number | null, income_vat_amount?: number | null, income_net_amount?: number | null, dt_income_withholding_tax_amount?: number | null, income_withholding_tax_amount?: number | null, income_total_amount?: number | null, description?: string | null, source_location?: string | null, destination_location?: string | null, vehicle_id: number, vehicle_details?: any | null, aggrid_status?: string | null, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null } }> | null, delivery_trip_item_list?: Array<{ __typename?: 'DeliveryTripItemList', unique_id: string, dt_unique_id: string, dt_job_no?: string | null, dt_issue_date: any, dt_vehicle_id: number, dt_vehicle_license_plate?: string | null, dt_vehicle_type?: string | null, dt_fuel_price?: number | null, income_unique_id: string, income_item_unique_id?: string | null, income_item_name?: string | null, income_item_pre_vat_amount?: number | null, description?: string | null }> | null } };

export type MaintenanceForReferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MaintenanceForReferencesQuery = { __typename?: 'Query', MaintenanceForReferences?: Array<{ __typename?: 'MaintenanceForReference', id: number, unique_id: string, ma_item_list?: Array<any> | null }> | null };

export type GenerateMaintenanceExportQueryVariables = Exact<{
  exportInput?: InputMaybe<GeneralExportInput>;
}>;


export type GenerateMaintenanceExportQuery = { __typename?: 'Query', GenerateMaintenanceExport?: string | null };

export type MaintenanceCreateMutationVariables = Exact<{
  createInput: MaintenanceCreateInput;
}>;


export type MaintenanceCreateMutation = { __typename?: 'Mutation', MaintenanceCreate?: { __typename?: 'Maintenance', id: number, unique_id: string, type: MaintenanceType, reference_no: string, created_date: any, created_by: any, last_updated_date?: any | null, last_updated_by?: any | null, driver_list?: Array<any> | null, issue_date: any, vehicle_id?: number | null, vehicle_details: any, trailer_id?: number | null, trailer_details?: any | null, ma_details: any, accident_date?: any | null, ma_start_date?: any | null, ma_end_date?: any | null, claim_no?: string | null, accident_location?: string | null, accident_description?: string | null, is_insurance_fully_paid?: boolean | null, price_vat_type: PriceVatType, ma_type?: Array<MaintenanceRepairType> | null, pre_vat_amount: number, additional_discount: number, additional_discount_type: MaintenanceDiscountType, post_discount_amount: number, vat_exempted_amount: number, vat_0_percent_amount: number, vat_7_percent_amount: number, vat_amount: number, net_amount: number, withholding_tax_amount: number, total_amount: number, remark?: string | null, attachment_list?: Array<any> | null, claim_attachment_list?: Array<any> | null, main_status: string, sub_status: string, flag_status?: Array<string> | null, aggrid_status: string, reference_document_list?: Array<any> | null, ma_item_list?: Array<{ __typename?: 'MaintenanceItem', id: number, unique_id: string, indexing: number, reference_unique_id: string, item_id?: number | null, item_unique_id: string, item_name: string, item_img_url?: Array<string> | null, item_sku_desc?: string | null, qty?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom_conversion_list?: Array<any> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, total_amount?: number | null, withholding_tax_value?: number | null, remark?: string | null, traceability?: Traceability | null, barcode?: string | null }> | null, ma_list?: Array<{ __typename?: 'MaintenanceTask', id: number, indexing?: number | null, name?: string | null, description?: string | null }> | null } | null };

export type MaintenanceUpdateMutationVariables = Exact<{
  uniqueInput: MaintenanceUniqueInput;
  updateInput: MaintenanceUpdateInput;
}>;


export type MaintenanceUpdateMutation = { __typename?: 'Mutation', MaintenanceUpdate?: { __typename?: 'Maintenance', id: number, unique_id: string, type: MaintenanceType, reference_no: string, created_date: any, created_by: any, last_updated_date?: any | null, last_updated_by?: any | null, driver_list?: Array<any> | null, issue_date: any, vehicle_id?: number | null, vehicle_details: any, trailer_id?: number | null, trailer_details?: any | null, ma_details: any, accident_date?: any | null, ma_start_date?: any | null, ma_end_date?: any | null, claim_no?: string | null, accident_location?: string | null, accident_description?: string | null, is_insurance_fully_paid?: boolean | null, price_vat_type: PriceVatType, ma_type?: Array<MaintenanceRepairType> | null, pre_vat_amount: number, additional_discount: number, additional_discount_type: MaintenanceDiscountType, post_discount_amount: number, vat_exempted_amount: number, vat_0_percent_amount: number, vat_7_percent_amount: number, vat_amount: number, net_amount: number, withholding_tax_amount: number, total_amount: number, remark?: string | null, attachment_list?: Array<any> | null, claim_attachment_list?: Array<any> | null, main_status: string, sub_status: string, flag_status?: Array<string> | null, aggrid_status: string, reference_document_list?: Array<any> | null, ma_item_list?: Array<{ __typename?: 'MaintenanceItem', id: number, unique_id: string, indexing: number, reference_unique_id: string, item_id?: number | null, item_unique_id: string, item_name: string, item_img_url?: Array<string> | null, item_sku_desc?: string | null, qty?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom_conversion_list?: Array<any> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, total_amount?: number | null, withholding_tax_value?: number | null, remark?: string | null, traceability?: Traceability | null, barcode?: string | null }> | null, ma_list?: Array<{ __typename?: 'MaintenanceTask', id: number, ma_reference_id?: number | null, indexing?: number | null, name?: string | null, description?: string | null }> | null } | null };

export type MaintenanceCancelMutationVariables = Exact<{
  uniqueInput: MaintenanceUniqueInput;
}>;


export type MaintenanceCancelMutation = { __typename?: 'Mutation', MaintenanceCancel?: { __typename?: 'Maintenance', id: number, unique_id: string, type: MaintenanceType, reference_no: string, created_date: any, created_by: any, last_updated_date?: any | null, last_updated_by?: any | null, driver_list?: Array<any> | null, issue_date: any, vehicle_id?: number | null, vehicle_details: any, trailer_id?: number | null, trailer_details?: any | null, ma_details: any, accident_date?: any | null, ma_start_date?: any | null, ma_end_date?: any | null, claim_no?: string | null, accident_location?: string | null, accident_description?: string | null, is_insurance_fully_paid?: boolean | null, price_vat_type: PriceVatType, ma_type?: Array<MaintenanceRepairType> | null, pre_vat_amount: number, additional_discount: number, additional_discount_type: MaintenanceDiscountType, post_discount_amount: number, vat_exempted_amount: number, vat_0_percent_amount: number, vat_7_percent_amount: number, vat_amount: number, net_amount: number, withholding_tax_amount: number, total_amount: number, remark?: string | null, attachment_list?: Array<any> | null, claim_attachment_list?: Array<any> | null, main_status: string, sub_status: string, flag_status?: Array<string> | null, aggrid_status: string, reference_document_list?: Array<any> | null, ma_item_list?: Array<{ __typename?: 'MaintenanceItem', id: number, unique_id: string, indexing: number, reference_unique_id: string, item_id?: number | null, item_unique_id: string, item_name: string, item_img_url?: Array<string> | null, item_sku_desc?: string | null, qty?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom_conversion_list?: Array<any> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, total_amount?: number | null, withholding_tax_value?: number | null, remark?: string | null, traceability?: Traceability | null, barcode?: string | null }> | null, ma_list?: Array<{ __typename?: 'MaintenanceTask', id: number, indexing?: number | null, name?: string | null, description?: string | null }> | null } | null };

export type MaintenanceFindAllQueryVariables = Exact<{ [key: string]: never; }>;


export type MaintenanceFindAllQuery = { __typename?: 'Query', MaintenanceFindAll?: Array<{ __typename?: 'Maintenance', id: number, unique_id: string, type: MaintenanceType, reference_no: string, created_date: any, created_by: any, last_updated_date?: any | null, last_updated_by?: any | null, driver_list?: Array<any> | null, issue_date: any, vehicle_id?: number | null, vehicle_details: any, trailer_id?: number | null, trailer_details?: any | null, ma_details: any, accident_date?: any | null, ma_start_date?: any | null, ma_end_date?: any | null, claim_no?: string | null, accident_location?: string | null, accident_description?: string | null, is_insurance_fully_paid?: boolean | null, price_vat_type: PriceVatType, ma_type?: Array<MaintenanceRepairType> | null, pre_vat_amount: number, additional_discount: number, additional_discount_type: MaintenanceDiscountType, post_discount_amount: number, vat_exempted_amount: number, vat_0_percent_amount: number, vat_7_percent_amount: number, vat_amount: number, net_amount: number, withholding_tax_amount: number, total_amount: number, remark?: string | null, attachment_list?: Array<any> | null, claim_attachment_list?: Array<any> | null, main_status: string, sub_status: string, flag_status?: Array<string> | null, aggrid_status: string, reference_document_list?: Array<any> | null, ma_item_list?: Array<{ __typename?: 'MaintenanceItem', id: number, unique_id: string, indexing: number, reference_unique_id: string, item_id?: number | null, item_unique_id: string, item_name: string, item_img_url?: Array<string> | null, item_sku_desc?: string | null, qty?: number | null, uom_id?: number | null, uom_name?: string | null, uom_conversion_list?: Array<any> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, total_amount?: number | null, withholding_tax_value?: number | null, remark?: string | null, traceability?: Traceability | null, barcode?: string | null }> | null, ma_list?: Array<{ __typename?: 'MaintenanceTask', id: number, indexing?: number | null, name?: string | null, description?: string | null }> | null }> | null };

export type MaintenanceFindUniqueQueryVariables = Exact<{
  uniqueInput: MaintenanceUniqueInput;
}>;


export type MaintenanceFindUniqueQuery = { __typename?: 'Query', MaintenanceFindUnique?: { __typename?: 'Maintenance', id: number, unique_id: string, type: MaintenanceType, reference_no: string, created_date: any, created_by: any, last_updated_date?: any | null, last_updated_by?: any | null, driver_list?: Array<any> | null, issue_date: any, vehicle_id?: number | null, vehicle_details: any, trailer_id?: number | null, trailer_details?: any | null, ma_details: any, accident_date?: any | null, ma_start_date?: any | null, ma_end_date?: any | null, claim_no?: string | null, accident_location?: string | null, accident_description?: string | null, is_insurance_fully_paid?: boolean | null, price_vat_type: PriceVatType, ma_type?: Array<MaintenanceRepairType> | null, pre_vat_amount: number, additional_discount: number, additional_discount_type: MaintenanceDiscountType, post_discount_amount: number, vat_exempted_amount: number, vat_0_percent_amount: number, vat_7_percent_amount: number, vat_amount: number, net_amount: number, withholding_tax_amount: number, total_amount: number, remark?: string | null, attachment_list?: Array<any> | null, claim_attachment_list?: Array<any> | null, main_status: string, sub_status: string, flag_status?: Array<string> | null, aggrid_status: string, reference_document_list?: Array<any> | null, ma_item_list?: Array<{ __typename?: 'MaintenanceItem', id: number, unique_id: string, indexing: number, reference_unique_id: string, item_id?: number | null, item_unique_id: string, item_name: string, item_img_url?: Array<string> | null, item_sku_desc?: string | null, qty?: number | null, qty_issued?: number | null, uom_id?: number | null, uom_name?: string | null, uom_conversion_list?: Array<any> | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, pre_discount_amount?: number | null, vat_amount?: number | null, additional_discount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, total_amount?: number | null, withholding_tax_value?: number | null, remark?: string | null, traceability?: Traceability | null, barcode?: string | null }> | null, ma_list?: Array<{ __typename?: 'MaintenanceTask', id: number, indexing?: number | null, name?: string | null, description?: string | null }> | null } | null };

export type QuotationCancelMutationVariables = Exact<{
  uniqueInput: QuotationUniqueInput;
}>;


export type QuotationCancelMutation = { __typename?: 'Mutation', QuotationCancel: { __typename?: 'Quotation', id: number, unique_id: string, created_date: any, last_updated_date: any, issue_date: any, due_date: any, credit_day?: number | null, plan_start_date?: any | null, plan_end_date?: any | null, contact_unique_id: string, vehicle_type: string, item_type: string, item_value: string, is_frozen: boolean, packing_location: string, expected_temperature?: string | null, container_type?: string | null, pre_discount_amount?: number | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, item_unique_id_list: Array<string>, accepted_date?: any | null, accepted_remark?: string | null, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, related_user_list: Array<{ __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }>, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null }, item_list: Array<{ __typename?: 'SalesItem', id: number, item_id: number, unique_id: string, item_unique_id: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url: Array<string>, uom_conversion_list?: Array<any> | null, uom_id?: number | null, uom_name?: string | null, qty: number, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_discount_amount?: number | null, vat_amount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, total_amount?: number | null, stock_qty?: number | null }>, attachment_list: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }> } };

export type QuotationCreateMutationVariables = Exact<{
  createInput: QuotationCreateInput;
}>;


export type QuotationCreateMutation = { __typename?: 'Mutation', QuotationCreate: { __typename?: 'Quotation', id: number, unique_id: string, created_date: any, last_updated_date: any, issue_date: any, due_date: any, credit_day?: number | null, plan_start_date?: any | null, plan_end_date?: any | null, contact_unique_id: string, vehicle_type: string, item_type: string, item_value: string, is_frozen: boolean, packing_location: string, expected_temperature?: string | null, container_type?: string | null, pre_discount_amount?: number | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, item_unique_id_list: Array<string>, accepted_date?: any | null, accepted_remark?: string | null, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, related_user_list: Array<{ __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }>, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null }, item_list: Array<{ __typename?: 'SalesItem', id: number, item_id: number, unique_id: string, item_unique_id: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url: Array<string>, uom_conversion_list?: Array<any> | null, uom_id?: number | null, uom_name?: string | null, qty: number, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_discount_amount?: number | null, vat_amount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, total_amount?: number | null, stock_qty?: number | null }>, attachment_list: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }> } };

export type QuotationFindUniqueQueryVariables = Exact<{
  uniqueInput: QuotationUniqueInput;
}>;


export type QuotationFindUniqueQuery = { __typename?: 'Query', QuotationFindUnique: { __typename?: 'Quotation', id: number, unique_id: string, created_date: any, last_updated_date: any, issue_date: any, due_date: any, credit_day?: number | null, plan_start_date?: any | null, plan_end_date?: any | null, contact_unique_id: string, vehicle_type: string, item_type: string, item_value: string, is_frozen: boolean, packing_location: string, expected_temperature?: string | null, container_type?: string | null, pre_discount_amount?: number | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, item_unique_id_list: Array<string>, accepted_date?: any | null, accepted_remark?: string | null, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, related_user_list: Array<{ __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }>, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null }, item_list: Array<{ __typename?: 'SalesItem', id: number, item_id: number, unique_id: string, item_unique_id: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url: Array<string>, uom_conversion_list?: Array<any> | null, uom_id?: number | null, uom_name?: string | null, qty: number, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_discount_amount?: number | null, vat_amount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, total_amount?: number | null, stock_qty?: number | null }>, attachment_list: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }> } };

export type QuotationUpdateMutationVariables = Exact<{
  uniqueInput: QuotationUniqueInput;
  updateInput: QuotationUpdateInput;
}>;


export type QuotationUpdateMutation = { __typename?: 'Mutation', QuotationUpdate: { __typename?: 'Quotation', id: number, unique_id: string, created_date: any, last_updated_date: any, issue_date: any, due_date: any, credit_day?: number | null, plan_start_date?: any | null, plan_end_date?: any | null, contact_unique_id: string, vehicle_type: string, item_type: string, item_value: string, is_frozen: boolean, packing_location: string, expected_temperature?: string | null, container_type?: string | null, pre_discount_amount?: number | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, item_unique_id_list: Array<string>, accepted_date?: any | null, accepted_remark?: string | null, created_by: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, related_user_list: Array<{ __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null }>, customer_details: { __typename?: 'SalesCustomerObject', customer_id?: number | null, customer_unique_id?: string | null, customer_name?: string | null, identity_no?: string | null, email?: string | null, phone?: string | null, fax?: string | null, billing_address?: { __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null } | null }, item_list: Array<{ __typename?: 'SalesItem', id: number, item_id: number, unique_id: string, item_unique_id: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url: Array<string>, uom_conversion_list?: Array<any> | null, uom_id?: number | null, uom_name?: string | null, qty: number, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_discount_amount?: number | null, vat_amount?: number | null, post_discount_amount?: number | null, net_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, total_amount?: number | null, stock_qty?: number | null }>, attachment_list: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }> } };


export const DeliveryTripCreateDocument = `
    mutation DeliveryTripCreate($createInput: DeliveryTripCreateInput!) {
  DeliveryTripCreate(createInput: $createInput) {
    id
    unique_id
    job_no
    created_date
    created_by
    last_updated_date
    last_updated_by
    related_user_list
    issue_date
    vehicle_id
    vehicle
    trailer_id
    trailer
    primary_driver
    secondary_driver
    customer_unique_id
    customer_details
    container_type
    item_type
    item_amount
    is_frozen
    temperature_type
    packaging_location
    expected_temperature
    plan_start_date
    plan_end_date
    actual_start_date
    actual_end_date
    start_kilometer
    end_kilometer
    total_kilometer_distance
    route_code
    plan_distance
    fuel_price
    temperature_start_hours
    temperature_end_hours
    total_temperature_hours
    fuel
    work_list {
      id
      index
      unique_id
      location_unique_id
      location_name
      type
      special_request
      customer_name
      coordinator_name
      coordinator_phone
      reference_code
      seal_no
      distance
      shipping_cost
      secondary_driver_cost
      drop_cost
      max_shipping_cost
      start_date
      end_date
      arrived_kilometer
      reference_unique_id
    }
    work_total_amount
    max_shipping_cost
    secondary_driver_cost
    drop_cost
    income_list {
      id
      index
      unique_id
      item_id
      item_unique_id
      item_name
      item_sku_desc
      qty
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      reference_unique_id
    }
    income_post_discount_amount
    income_vat_exempted_amount
    income_vat_0_percent_amount
    income_vat_7_percent_amount
    income_vat_amount
    income_net_amount
    income_withholding_tax_amount
    income_total_amount
    expenses_list {
      id
      index
      unique_id
      item_id
      item_unique_id
      item_name
      item_sku_desc
      qty
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      reference_unique_id
      driver_no
      net_amount
      withholding_tax_amount
      total_amount
    }
    expenses_post_discount_amount
    expenses_vat_exempted_amount
    expenses_vat_0_percent_amount
    expenses_vat_7_percent_amount
    expenses_vat_amount
    expenses_net_amount
    expenses_withholding_tax_amount
    expenses_total_amount
    main_status
    sub_status
    flag_status
    aggrid_status
    attachment_list
    remark
    reference_document_list
  }
}
    `;
export const useDeliveryTripCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeliveryTripCreateMutation, TError, DeliveryTripCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeliveryTripCreateMutation, TError, DeliveryTripCreateMutationVariables, TContext>(
      ['DeliveryTripCreate'],
      (variables?: DeliveryTripCreateMutationVariables) => fetcher<DeliveryTripCreateMutation, DeliveryTripCreateMutationVariables>(client, DeliveryTripCreateDocument, variables, headers)(),
      options
    );
export const DeliveryTripFindUniqueDocument = `
    query DeliveryTripFindUnique($uniqueInput: DeliveryUniqueInput!) {
  DeliveryTripFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    job_no
    created_date
    created_by
    last_updated_date
    last_updated_by
    related_user_list
    issue_date
    vehicle_id
    vehicle
    trailer_id
    trailer
    primary_driver
    secondary_driver
    customer_unique_id
    customer_details
    container_type
    item_type
    item_amount
    is_frozen
    temperature_type
    packaging_location
    expected_temperature
    plan_start_date
    plan_end_date
    actual_start_date
    actual_end_date
    start_kilometer
    end_kilometer
    total_kilometer_distance
    route_code
    plan_distance
    fuel_price
    temperature_start_hours
    temperature_end_hours
    total_temperature_hours
    fuel
    work_list {
      id
      index
      unique_id
      location_unique_id
      location_name
      type
      special_request
      customer_name
      coordinator_name
      coordinator_phone
      reference_code
      seal_no
      distance
      shipping_cost
      secondary_driver_cost
      drop_cost
      max_shipping_cost
      start_date
      end_date
      arrived_kilometer
      reference_unique_id
    }
    work_total_amount
    max_shipping_cost
    secondary_driver_cost
    drop_cost
    income_list {
      id
      index
      unique_id
      item_id
      item_unique_id
      item_name
      item_sku_desc
      qty
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      reference_unique_id
    }
    income_post_discount_amount
    income_vat_exempted_amount
    income_vat_0_percent_amount
    income_vat_7_percent_amount
    income_vat_amount
    income_net_amount
    income_withholding_tax_amount
    income_total_amount
    expenses_list {
      id
      index
      unique_id
      item_id
      item_unique_id
      item_name
      item_sku_desc
      qty
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      reference_unique_id
      driver_no
      net_amount
      withholding_tax_amount
      total_amount
    }
    expenses_post_discount_amount
    expenses_vat_exempted_amount
    expenses_vat_0_percent_amount
    expenses_vat_7_percent_amount
    expenses_vat_amount
    expenses_net_amount
    expenses_withholding_tax_amount
    expenses_total_amount
    main_status
    sub_status
    flag_status
    aggrid_status
    attachment_list
    remark
    reference_document_list
    payment_date
    payment_detail
    payment_status
    created_payment_date
  }
}
    `;
export const useDeliveryTripFindUniqueQuery = <
      TData = DeliveryTripFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: DeliveryTripFindUniqueQueryVariables,
      options?: UseQueryOptions<DeliveryTripFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<DeliveryTripFindUniqueQuery, TError, TData>(
      ['DeliveryTripFindUnique', variables],
      fetcher<DeliveryTripFindUniqueQuery, DeliveryTripFindUniqueQueryVariables>(client, DeliveryTripFindUniqueDocument, variables, headers),
      options
    );
export const DeliveryTripUpdateDocument = `
    mutation DeliveryTripUpdate($uniqueInput: DeliveryUniqueInput!, $updateInput: DeliveryTripUpdateInput!) {
  DeliveryTripUpdate(uniqueInput: $uniqueInput, updateInput: $updateInput) {
    id
    unique_id
    job_no
    created_date
    created_by
    last_updated_date
    last_updated_by
    related_user_list
    issue_date
    vehicle_id
    vehicle
    trailer_id
    trailer
    primary_driver
    secondary_driver
    customer_unique_id
    customer_details
    container_type
    item_type
    item_amount
    is_frozen
    temperature_type
    packaging_location
    expected_temperature
    plan_start_date
    plan_end_date
    actual_start_date
    actual_end_date
    start_kilometer
    end_kilometer
    total_kilometer_distance
    route_code
    plan_distance
    fuel_price
    temperature_start_hours
    temperature_end_hours
    total_temperature_hours
    fuel
    work_list {
      id
      index
      unique_id
      location_unique_id
      location_name
      type
      special_request
      customer_name
      coordinator_name
      coordinator_phone
      reference_code
      seal_no
      distance
      shipping_cost
      secondary_driver_cost
      drop_cost
      max_shipping_cost
      start_date
      end_date
      arrived_kilometer
      reference_unique_id
    }
    work_total_amount
    max_shipping_cost
    secondary_driver_cost
    drop_cost
    income_list {
      id
      index
      unique_id
      item_id
      item_unique_id
      item_name
      item_sku_desc
      qty
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      reference_unique_id
    }
    income_post_discount_amount
    income_vat_exempted_amount
    income_vat_0_percent_amount
    income_vat_7_percent_amount
    income_vat_amount
    income_net_amount
    income_withholding_tax_amount
    income_total_amount
    expenses_list {
      id
      index
      unique_id
      item_id
      item_unique_id
      item_name
      item_sku_desc
      qty
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      reference_unique_id
      driver_no
      net_amount
      withholding_tax_amount
      total_amount
    }
    expenses_post_discount_amount
    expenses_vat_exempted_amount
    expenses_vat_0_percent_amount
    expenses_vat_7_percent_amount
    expenses_vat_amount
    expenses_net_amount
    expenses_withholding_tax_amount
    expenses_total_amount
    main_status
    sub_status
    flag_status
    aggrid_status
    attachment_list
    remark
    reference_document_list
    payment_date
    payment_detail
    payment_status
    created_payment_date
  }
}
    `;
export const useDeliveryTripUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeliveryTripUpdateMutation, TError, DeliveryTripUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeliveryTripUpdateMutation, TError, DeliveryTripUpdateMutationVariables, TContext>(
      ['DeliveryTripUpdate'],
      (variables?: DeliveryTripUpdateMutationVariables) => fetcher<DeliveryTripUpdateMutation, DeliveryTripUpdateMutationVariables>(client, DeliveryTripUpdateDocument, variables, headers)(),
      options
    );
export const SalesUniqueIdGenerateDocument = `
    query SalesUniqueIdGenerate($modelType: SalesModelType!, $issueDate: String) {
  UniqueIdGenerate(modelType: $modelType, issueDate: $issueDate)
}
    `;
export const useSalesUniqueIdGenerateQuery = <
      TData = SalesUniqueIdGenerateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SalesUniqueIdGenerateQueryVariables,
      options?: UseQueryOptions<SalesUniqueIdGenerateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SalesUniqueIdGenerateQuery, TError, TData>(
      ['SalesUniqueIdGenerate', variables],
      fetcher<SalesUniqueIdGenerateQuery, SalesUniqueIdGenerateQueryVariables>(client, SalesUniqueIdGenerateDocument, variables, headers),
      options
    );
export const TireCreateDocument = `
    mutation TireCreate($createTireInput: CreateTireInput!) {
  TireCreate(createTireInput: $createTireInput) {
    id
    serial
    model
    band
    current_distance
    due_distance
    price_per_unit
    status
    position
    remark
    vehicle_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
  }
}
    `;
export const useTireCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TireCreateMutation, TError, TireCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TireCreateMutation, TError, TireCreateMutationVariables, TContext>(
      ['TireCreate'],
      (variables?: TireCreateMutationVariables) => fetcher<TireCreateMutation, TireCreateMutationVariables>(client, TireCreateDocument, variables, headers)(),
      options
    );
export const TireUsageGenerateExportDocument = `
    query TireUsageGenerateExport($input: TireUsageGenerateExportInput) {
  TireUsageGenerateExport(input: $input)
}
    `;
export const useTireUsageGenerateExportQuery = <
      TData = TireUsageGenerateExportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: TireUsageGenerateExportQueryVariables,
      options?: UseQueryOptions<TireUsageGenerateExportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TireUsageGenerateExportQuery, TError, TData>(
      variables === undefined ? ['TireUsageGenerateExport'] : ['TireUsageGenerateExport', variables],
      fetcher<TireUsageGenerateExportQuery, TireUsageGenerateExportQueryVariables>(client, TireUsageGenerateExportDocument, variables, headers),
      options
    );
export const TireFineUniqueDocument = `
    query TireFineUnique($tireFineUniqueId: Int!) {
  TireFineUnique(id: $tireFineUniqueId) {
    id
    serial
    model
    band
    current_distance
    due_distance
    price_per_unit
    status
    remark
    created_date
    created_by
    last_updated_date
    last_updated_by
    is_active
  }
}
    `;
export const useTireFineUniqueQuery = <
      TData = TireFineUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: TireFineUniqueQueryVariables,
      options?: UseQueryOptions<TireFineUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TireFineUniqueQuery, TError, TData>(
      ['TireFineUnique', variables],
      fetcher<TireFineUniqueQuery, TireFineUniqueQueryVariables>(client, TireFineUniqueDocument, variables, headers),
      options
    );
export const TireRemoveDocument = `
    mutation TireRemove($tireRemoveId: Int!) {
  TireRemove(id: $tireRemoveId)
}
    `;
export const useTireRemoveMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TireRemoveMutation, TError, TireRemoveMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TireRemoveMutation, TError, TireRemoveMutationVariables, TContext>(
      ['TireRemove'],
      (variables?: TireRemoveMutationVariables) => fetcher<TireRemoveMutation, TireRemoveMutationVariables>(client, TireRemoveDocument, variables, headers)(),
      options
    );
export const TireUpdateDocument = `
    mutation TireUpdate($updateTireInput: UpdateTireInput!) {
  TireUpdate(updateTireInput: $updateTireInput) {
    id
    serial
    model
    band
    current_distance
    due_distance
    price_per_unit
    status
    position
    remark
    vehicle_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
  }
}
    `;
export const useTireUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TireUpdateMutation, TError, TireUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TireUpdateMutation, TError, TireUpdateMutationVariables, TContext>(
      ['TireUpdate'],
      (variables?: TireUpdateMutationVariables) => fetcher<TireUpdateMutation, TireUpdateMutationVariables>(client, TireUpdateDocument, variables, headers)(),
      options
    );
export const BillingNoteCancelDocument = `
    mutation BillingNoteCancel($uniqueInput: BillingNoteUniqueInput!) {
  BillingNoteCancel(uniqueInput: $uniqueInput) {
    id
    unique_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    due_date
    credit_day
    related_user_list {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    company_type
    customer_unique_id
    customer_details {
      customer_id
      customer_unique_id
      customer_name
      identity_no
      email
      phone
      fax
      billing_address {
        is_default
        is_same_as_default_address
        address_type
        address_contact_name
        address_contact_phone
        address_contact_fax
        name
        sub_district
        district
        province
        postal_code
        country
      }
    }
    pre_discount_amount
    discount_type
    discount
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_type
    vat_amount
    net_amount
    withholding_tax_percent
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    accepted_date
    accepted_remark
    attachment_list {
      attachment_name
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
      uploaded_date
      url
    }
    item_list {
      id
      unique_id
      dt_reference_unique_id
      dt_income_unique_id
      issue_date
      dt_income_post_discount_amount
      income_post_discount_amount
      income_vat_exempted_amount
      income_vat_0_percent_amount
      income_vat_7_percent_amount
      income_vat_amount
      income_net_amount
      dt_income_withholding_tax_amount
      income_withholding_tax_amount
      income_total_amount
      description
      source_location
      destination_location
      vehicle_id
      vehicle_details
      aggrid_status
      customer_details {
        customer_id
        customer_unique_id
        customer_name
        identity_no
        email
        phone
        fax
        billing_address {
          is_default
          is_same_as_default_address
          address_type
          address_contact_name
          address_contact_phone
          address_contact_fax
          name
          sub_district
          district
          province
          postal_code
          country
        }
      }
    }
    delivery_trip_item_list {
      unique_id
      dt_unique_id
      dt_job_no
      dt_issue_date
      dt_vehicle_id
      dt_vehicle_license_plate
      dt_vehicle_type
      dt_fuel_price
      income_unique_id
      income_item_unique_id
      income_item_name
      income_item_pre_vat_amount
      description
    }
  }
}
    `;
export const useBillingNoteCancelMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BillingNoteCancelMutation, TError, BillingNoteCancelMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BillingNoteCancelMutation, TError, BillingNoteCancelMutationVariables, TContext>(
      ['BillingNoteCancel'],
      (variables?: BillingNoteCancelMutationVariables) => fetcher<BillingNoteCancelMutation, BillingNoteCancelMutationVariables>(client, BillingNoteCancelDocument, variables, headers)(),
      options
    );
export const BillingNoteCreateDocument = `
    mutation BillingNoteCreate($createInput: BillingNoteCreateInput!) {
  BillingNoteCreate(createInput: $createInput) {
    id
    unique_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    due_date
    credit_day
    related_user_list {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    company_type
    customer_unique_id
    customer_details {
      customer_id
      customer_unique_id
      customer_name
      identity_no
      email
      phone
      fax
      billing_address {
        is_default
        is_same_as_default_address
        address_type
        address_contact_name
        address_contact_phone
        address_contact_fax
        name
        sub_district
        district
        province
        postal_code
        country
      }
    }
    pre_discount_amount
    discount_type
    discount
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_type
    vat_amount
    net_amount
    withholding_tax_percent
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    accepted_date
    accepted_remark
    attachment_list {
      attachment_name
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
      uploaded_date
      url
    }
    item_list {
      id
      unique_id
      dt_reference_unique_id
      dt_income_unique_id
      issue_date
      dt_income_post_discount_amount
      income_post_discount_amount
      income_vat_exempted_amount
      income_vat_0_percent_amount
      income_vat_7_percent_amount
      income_vat_amount
      income_net_amount
      dt_income_withholding_tax_amount
      income_withholding_tax_amount
      income_total_amount
      description
      source_location
      destination_location
      vehicle_id
      vehicle_details
      aggrid_status
      customer_details {
        customer_id
        customer_unique_id
        customer_name
        identity_no
        email
        phone
        fax
        billing_address {
          is_default
          is_same_as_default_address
          address_type
          address_contact_name
          address_contact_phone
          address_contact_fax
          name
          sub_district
          district
          province
          postal_code
          country
        }
      }
    }
    delivery_trip_item_list {
      unique_id
      dt_unique_id
      dt_job_no
      dt_issue_date
      dt_vehicle_id
      dt_vehicle_license_plate
      dt_vehicle_type
      dt_fuel_price
      income_unique_id
      income_item_unique_id
      income_item_name
      income_item_pre_vat_amount
      description
    }
  }
}
    `;
export const useBillingNoteCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BillingNoteCreateMutation, TError, BillingNoteCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BillingNoteCreateMutation, TError, BillingNoteCreateMutationVariables, TContext>(
      ['BillingNoteCreate'],
      (variables?: BillingNoteCreateMutationVariables) => fetcher<BillingNoteCreateMutation, BillingNoteCreateMutationVariables>(client, BillingNoteCreateDocument, variables, headers)(),
      options
    );
export const BillingNoteFindUniqueDocument = `
    query BillingNoteFindUnique($uniqueInput: BillingNoteUniqueInput!) {
  BillingNoteFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    due_date
    credit_day
    related_user_list {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    company_type
    customer_unique_id
    customer_details {
      customer_id
      customer_unique_id
      customer_name
      identity_no
      email
      phone
      fax
      billing_address {
        is_default
        is_same_as_default_address
        address_type
        address_contact_name
        address_contact_phone
        address_contact_fax
        name
        sub_district
        district
        province
        postal_code
        country
      }
    }
    pre_discount_amount
    discount_type
    discount
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_type
    vat_amount
    net_amount
    withholding_tax_percent
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    accepted_date
    accepted_remark
    attachment_list {
      attachment_name
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
      uploaded_date
      url
    }
    item_list {
      id
      unique_id
      dt_reference_unique_id
      dt_income_unique_id
      issue_date
      dt_income_post_discount_amount
      income_post_discount_amount
      income_vat_exempted_amount
      income_vat_0_percent_amount
      income_vat_7_percent_amount
      income_vat_amount
      income_net_amount
      dt_income_withholding_tax_amount
      income_withholding_tax_amount
      income_total_amount
      description
      source_location
      destination_location
      vehicle_id
      vehicle_details
      aggrid_status
      customer_details {
        customer_id
        customer_unique_id
        customer_name
        identity_no
        email
        phone
        fax
        billing_address {
          is_default
          is_same_as_default_address
          address_type
          address_contact_name
          address_contact_phone
          address_contact_fax
          name
          sub_district
          district
          province
          postal_code
          country
        }
      }
    }
    delivery_trip_item_list {
      unique_id
      dt_unique_id
      dt_job_no
      dt_issue_date
      dt_vehicle_id
      dt_vehicle_license_plate
      dt_vehicle_type
      dt_fuel_price
      income_unique_id
      income_item_unique_id
      income_item_name
      income_item_pre_vat_amount
      description
    }
  }
}
    `;
export const useBillingNoteFindUniqueQuery = <
      TData = BillingNoteFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: BillingNoteFindUniqueQueryVariables,
      options?: UseQueryOptions<BillingNoteFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BillingNoteFindUniqueQuery, TError, TData>(
      ['BillingNoteFindUnique', variables],
      fetcher<BillingNoteFindUniqueQuery, BillingNoteFindUniqueQueryVariables>(client, BillingNoteFindUniqueDocument, variables, headers),
      options
    );
export const BillingNoteUpdateDocument = `
    mutation BillingNoteUpdate($uniqueInput: BillingNoteUniqueInput!, $updateInput: BillingNoteUpdateInput!) {
  BillingNoteUpdate(uniqueInput: $uniqueInput, updateInput: $updateInput) {
    id
    unique_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    due_date
    credit_day
    related_user_list {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    company_type
    customer_unique_id
    customer_details {
      customer_id
      customer_unique_id
      customer_name
      identity_no
      email
      phone
      fax
      billing_address {
        is_default
        is_same_as_default_address
        address_type
        address_contact_name
        address_contact_phone
        address_contact_fax
        name
        sub_district
        district
        province
        postal_code
        country
      }
    }
    pre_discount_amount
    discount_type
    discount
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_type
    vat_amount
    net_amount
    withholding_tax_percent
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    accepted_date
    accepted_remark
    attachment_list {
      attachment_name
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
      uploaded_date
      url
    }
    item_list {
      id
      unique_id
      dt_reference_unique_id
      dt_income_unique_id
      issue_date
      dt_income_post_discount_amount
      income_post_discount_amount
      income_vat_exempted_amount
      income_vat_0_percent_amount
      income_vat_7_percent_amount
      income_vat_amount
      income_net_amount
      dt_income_withholding_tax_amount
      income_withholding_tax_amount
      income_total_amount
      description
      source_location
      destination_location
      vehicle_id
      vehicle_details
      aggrid_status
      customer_details {
        customer_id
        customer_unique_id
        customer_name
        identity_no
        email
        phone
        fax
        billing_address {
          is_default
          is_same_as_default_address
          address_type
          address_contact_name
          address_contact_phone
          address_contact_fax
          name
          sub_district
          district
          province
          postal_code
          country
        }
      }
    }
    delivery_trip_item_list {
      unique_id
      dt_unique_id
      dt_job_no
      dt_issue_date
      dt_vehicle_id
      dt_vehicle_license_plate
      dt_vehicle_type
      dt_fuel_price
      income_unique_id
      income_item_unique_id
      income_item_name
      income_item_pre_vat_amount
      description
    }
  }
}
    `;
export const useBillingNoteUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BillingNoteUpdateMutation, TError, BillingNoteUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BillingNoteUpdateMutation, TError, BillingNoteUpdateMutationVariables, TContext>(
      ['BillingNoteUpdate'],
      (variables?: BillingNoteUpdateMutationVariables) => fetcher<BillingNoteUpdateMutation, BillingNoteUpdateMutationVariables>(client, BillingNoteUpdateDocument, variables, headers)(),
      options
    );
export const MaintenanceForReferencesDocument = `
    query MaintenanceForReferences {
  MaintenanceForReferences {
    id
    unique_id
    ma_item_list
  }
}
    `;
export const useMaintenanceForReferencesQuery = <
      TData = MaintenanceForReferencesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MaintenanceForReferencesQueryVariables,
      options?: UseQueryOptions<MaintenanceForReferencesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MaintenanceForReferencesQuery, TError, TData>(
      variables === undefined ? ['MaintenanceForReferences'] : ['MaintenanceForReferences', variables],
      fetcher<MaintenanceForReferencesQuery, MaintenanceForReferencesQueryVariables>(client, MaintenanceForReferencesDocument, variables, headers),
      options
    );
export const GenerateMaintenanceExportDocument = `
    query GenerateMaintenanceExport($exportInput: GeneralExportInput) {
  GenerateMaintenanceExport(exportInput: $exportInput)
}
    `;
export const useGenerateMaintenanceExportQuery = <
      TData = GenerateMaintenanceExportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GenerateMaintenanceExportQueryVariables,
      options?: UseQueryOptions<GenerateMaintenanceExportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GenerateMaintenanceExportQuery, TError, TData>(
      variables === undefined ? ['GenerateMaintenanceExport'] : ['GenerateMaintenanceExport', variables],
      fetcher<GenerateMaintenanceExportQuery, GenerateMaintenanceExportQueryVariables>(client, GenerateMaintenanceExportDocument, variables, headers),
      options
    );
export const MaintenanceCreateDocument = `
    mutation MaintenanceCreate($createInput: MaintenanceCreateInput!) {
  MaintenanceCreate(createInput: $createInput) {
    id
    unique_id
    type
    reference_no
    created_date
    created_by
    last_updated_date
    last_updated_by
    driver_list
    issue_date
    vehicle_id
    vehicle_details
    trailer_id
    trailer_details
    ma_details
    accident_date
    ma_start_date
    ma_end_date
    claim_no
    accident_location
    accident_description
    is_insurance_fully_paid
    price_vat_type
    ma_type
    ma_item_list {
      id
      unique_id
      indexing
      reference_unique_id
      item_id
      item_unique_id
      item_name
      item_img_url
      item_sku_desc
      qty
      qty_issued
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      stock_qty
      withholding_tax_type
      total_amount
      withholding_tax_value
      remark
      traceability
      barcode
    }
    ma_list {
      id
      indexing
      name
      description
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    attachment_list
    claim_attachment_list
    main_status
    sub_status
    flag_status
    aggrid_status
    reference_document_list
  }
}
    `;
export const useMaintenanceCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MaintenanceCreateMutation, TError, MaintenanceCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MaintenanceCreateMutation, TError, MaintenanceCreateMutationVariables, TContext>(
      ['MaintenanceCreate'],
      (variables?: MaintenanceCreateMutationVariables) => fetcher<MaintenanceCreateMutation, MaintenanceCreateMutationVariables>(client, MaintenanceCreateDocument, variables, headers)(),
      options
    );
export const MaintenanceUpdateDocument = `
    mutation MaintenanceUpdate($uniqueInput: MaintenanceUniqueInput!, $updateInput: MaintenanceUpdateInput!) {
  MaintenanceUpdate(uniqueInput: $uniqueInput, updateInput: $updateInput) {
    id
    unique_id
    type
    reference_no
    created_date
    created_by
    last_updated_date
    last_updated_by
    driver_list
    issue_date
    vehicle_id
    vehicle_details
    trailer_id
    trailer_details
    ma_details
    accident_date
    ma_start_date
    ma_end_date
    claim_no
    accident_location
    accident_description
    is_insurance_fully_paid
    price_vat_type
    ma_type
    ma_item_list {
      id
      unique_id
      indexing
      reference_unique_id
      item_id
      item_unique_id
      item_name
      item_img_url
      item_sku_desc
      qty
      qty_issued
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      stock_qty
      withholding_tax_type
      total_amount
      withholding_tax_value
      remark
      traceability
      barcode
    }
    ma_list {
      id
      ma_reference_id
      indexing
      name
      description
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    attachment_list
    claim_attachment_list
    main_status
    sub_status
    flag_status
    aggrid_status
    reference_document_list
  }
}
    `;
export const useMaintenanceUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MaintenanceUpdateMutation, TError, MaintenanceUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MaintenanceUpdateMutation, TError, MaintenanceUpdateMutationVariables, TContext>(
      ['MaintenanceUpdate'],
      (variables?: MaintenanceUpdateMutationVariables) => fetcher<MaintenanceUpdateMutation, MaintenanceUpdateMutationVariables>(client, MaintenanceUpdateDocument, variables, headers)(),
      options
    );
export const MaintenanceCancelDocument = `
    mutation MaintenanceCancel($uniqueInput: MaintenanceUniqueInput!) {
  MaintenanceCancel(uniqueInput: $uniqueInput) {
    id
    unique_id
    type
    reference_no
    created_date
    created_by
    last_updated_date
    last_updated_by
    driver_list
    issue_date
    vehicle_id
    vehicle_details
    trailer_id
    trailer_details
    ma_details
    accident_date
    ma_start_date
    ma_end_date
    claim_no
    accident_location
    accident_description
    is_insurance_fully_paid
    price_vat_type
    ma_type
    ma_item_list {
      id
      unique_id
      indexing
      reference_unique_id
      item_id
      item_unique_id
      item_name
      item_img_url
      item_sku_desc
      qty
      qty_issued
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      stock_qty
      withholding_tax_type
      total_amount
      withholding_tax_value
      remark
      traceability
      barcode
    }
    ma_list {
      id
      indexing
      name
      description
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    attachment_list
    claim_attachment_list
    main_status
    sub_status
    flag_status
    aggrid_status
    reference_document_list
  }
}
    `;
export const useMaintenanceCancelMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MaintenanceCancelMutation, TError, MaintenanceCancelMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MaintenanceCancelMutation, TError, MaintenanceCancelMutationVariables, TContext>(
      ['MaintenanceCancel'],
      (variables?: MaintenanceCancelMutationVariables) => fetcher<MaintenanceCancelMutation, MaintenanceCancelMutationVariables>(client, MaintenanceCancelDocument, variables, headers)(),
      options
    );
export const MaintenanceFindAllDocument = `
    query MaintenanceFindAll {
  MaintenanceFindAll {
    id
    unique_id
    type
    reference_no
    created_date
    created_by
    last_updated_date
    last_updated_by
    driver_list
    issue_date
    vehicle_id
    vehicle_details
    trailer_id
    trailer_details
    ma_details
    accident_date
    ma_start_date
    ma_end_date
    claim_no
    accident_location
    accident_description
    is_insurance_fully_paid
    price_vat_type
    ma_type
    ma_item_list {
      id
      unique_id
      indexing
      reference_unique_id
      item_id
      item_unique_id
      item_name
      item_img_url
      item_sku_desc
      qty
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      stock_qty
      withholding_tax_type
      total_amount
      withholding_tax_value
      remark
      traceability
      barcode
    }
    ma_list {
      id
      indexing
      name
      description
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    attachment_list
    claim_attachment_list
    main_status
    sub_status
    flag_status
    aggrid_status
    reference_document_list
  }
}
    `;
export const useMaintenanceFindAllQuery = <
      TData = MaintenanceFindAllQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MaintenanceFindAllQueryVariables,
      options?: UseQueryOptions<MaintenanceFindAllQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MaintenanceFindAllQuery, TError, TData>(
      variables === undefined ? ['MaintenanceFindAll'] : ['MaintenanceFindAll', variables],
      fetcher<MaintenanceFindAllQuery, MaintenanceFindAllQueryVariables>(client, MaintenanceFindAllDocument, variables, headers),
      options
    );
export const MaintenanceFindUniqueDocument = `
    query MaintenanceFindUnique($uniqueInput: MaintenanceUniqueInput!) {
  MaintenanceFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    type
    reference_no
    created_date
    created_by
    last_updated_date
    last_updated_by
    driver_list
    issue_date
    vehicle_id
    vehicle_details
    trailer_id
    trailer_details
    ma_details
    accident_date
    ma_start_date
    ma_end_date
    claim_no
    accident_location
    accident_description
    is_insurance_fully_paid
    price_vat_type
    ma_type
    ma_item_list {
      id
      unique_id
      indexing
      reference_unique_id
      item_id
      item_unique_id
      item_name
      item_img_url
      item_sku_desc
      qty
      qty_issued
      uom_id
      uom_name
      uom_conversion_list
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      pre_discount_amount
      vat_amount
      additional_discount
      post_discount_amount
      net_amount
      stock_qty
      withholding_tax_type
      total_amount
      withholding_tax_value
      remark
      traceability
      barcode
    }
    ma_list {
      id
      indexing
      name
      description
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    attachment_list
    claim_attachment_list
    main_status
    sub_status
    flag_status
    aggrid_status
    reference_document_list
  }
}
    `;
export const useMaintenanceFindUniqueQuery = <
      TData = MaintenanceFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: MaintenanceFindUniqueQueryVariables,
      options?: UseQueryOptions<MaintenanceFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MaintenanceFindUniqueQuery, TError, TData>(
      ['MaintenanceFindUnique', variables],
      fetcher<MaintenanceFindUniqueQuery, MaintenanceFindUniqueQueryVariables>(client, MaintenanceFindUniqueDocument, variables, headers),
      options
    );
export const QuotationCancelDocument = `
    mutation QuotationCancel($uniqueInput: QuotationUniqueInput!) {
  QuotationCancel(uniqueInput: $uniqueInput) {
    id
    unique_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    due_date
    credit_day
    plan_start_date
    plan_end_date
    related_user_list {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    contact_unique_id
    customer_details {
      customer_id
      customer_unique_id
      customer_name
      identity_no
      email
      phone
      fax
      billing_address {
        is_default
        is_same_as_default_address
        address_type
        address_contact_name
        address_contact_phone
        address_contact_fax
        name
        sub_district
        district
        province
        postal_code
        country
      }
    }
    vehicle_type
    item_type
    item_value
    is_frozen
    packing_location
    expected_temperature
    container_type
    pre_discount_amount
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    item_unique_id_list
    item_list {
      id
      item_id
      unique_id
      item_unique_id
      item_name
      item_sku_desc
      item_img_url
      uom_conversion_list
      uom_id
      uom_name
      qty
      price_per_unit
      discount
      vat_percentage
      pre_discount_amount
      vat_amount
      post_discount_amount
      net_amount
      withholding_tax_type
      withholding_tax_value
      total_amount
      stock_qty
    }
    accepted_date
    accepted_remark
    attachment_list {
      attachment_name
      uploaded_date
      url
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
    }
  }
}
    `;
export const useQuotationCancelMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<QuotationCancelMutation, TError, QuotationCancelMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<QuotationCancelMutation, TError, QuotationCancelMutationVariables, TContext>(
      ['QuotationCancel'],
      (variables?: QuotationCancelMutationVariables) => fetcher<QuotationCancelMutation, QuotationCancelMutationVariables>(client, QuotationCancelDocument, variables, headers)(),
      options
    );
export const QuotationCreateDocument = `
    mutation QuotationCreate($createInput: QuotationCreateInput!) {
  QuotationCreate(createInput: $createInput) {
    id
    unique_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    due_date
    credit_day
    plan_start_date
    plan_end_date
    related_user_list {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    contact_unique_id
    customer_details {
      customer_id
      customer_unique_id
      customer_name
      identity_no
      email
      phone
      fax
      billing_address {
        is_default
        is_same_as_default_address
        address_type
        address_contact_name
        address_contact_phone
        address_contact_fax
        name
        sub_district
        district
        province
        postal_code
        country
      }
    }
    vehicle_type
    item_type
    item_value
    is_frozen
    packing_location
    expected_temperature
    container_type
    pre_discount_amount
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    item_unique_id_list
    item_list {
      id
      item_id
      unique_id
      item_unique_id
      item_name
      item_sku_desc
      item_img_url
      uom_conversion_list
      uom_id
      uom_name
      qty
      price_per_unit
      discount
      vat_percentage
      pre_discount_amount
      vat_amount
      post_discount_amount
      net_amount
      withholding_tax_type
      withholding_tax_value
      total_amount
      stock_qty
    }
    accepted_date
    accepted_remark
    attachment_list {
      attachment_name
      uploaded_date
      url
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
    }
  }
}
    `;
export const useQuotationCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<QuotationCreateMutation, TError, QuotationCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<QuotationCreateMutation, TError, QuotationCreateMutationVariables, TContext>(
      ['QuotationCreate'],
      (variables?: QuotationCreateMutationVariables) => fetcher<QuotationCreateMutation, QuotationCreateMutationVariables>(client, QuotationCreateDocument, variables, headers)(),
      options
    );
export const QuotationFindUniqueDocument = `
    query QuotationFindUnique($uniqueInput: QuotationUniqueInput!) {
  QuotationFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    due_date
    credit_day
    plan_start_date
    plan_end_date
    related_user_list {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    contact_unique_id
    customer_details {
      customer_id
      customer_unique_id
      customer_name
      identity_no
      email
      phone
      fax
      billing_address {
        is_default
        is_same_as_default_address
        address_type
        address_contact_name
        address_contact_phone
        address_contact_fax
        name
        sub_district
        district
        province
        postal_code
        country
      }
    }
    vehicle_type
    item_type
    item_value
    is_frozen
    packing_location
    expected_temperature
    container_type
    pre_discount_amount
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    item_unique_id_list
    item_list {
      id
      item_id
      unique_id
      item_unique_id
      item_name
      item_sku_desc
      item_img_url
      uom_conversion_list
      uom_id
      uom_name
      qty
      price_per_unit
      discount
      vat_percentage
      pre_discount_amount
      vat_amount
      post_discount_amount
      net_amount
      withholding_tax_type
      withholding_tax_value
      total_amount
      stock_qty
    }
    accepted_date
    accepted_remark
    attachment_list {
      attachment_name
      uploaded_date
      url
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
    }
  }
}
    `;
export const useQuotationFindUniqueQuery = <
      TData = QuotationFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: QuotationFindUniqueQueryVariables,
      options?: UseQueryOptions<QuotationFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<QuotationFindUniqueQuery, TError, TData>(
      ['QuotationFindUnique', variables],
      fetcher<QuotationFindUniqueQuery, QuotationFindUniqueQueryVariables>(client, QuotationFindUniqueDocument, variables, headers),
      options
    );
export const QuotationUpdateDocument = `
    mutation QuotationUpdate($uniqueInput: QuotationUniqueInput!, $updateInput: QuotationUpdateInput!) {
  QuotationUpdate(uniqueInput: $uniqueInput, updateInput: $updateInput) {
    id
    unique_id
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    due_date
    credit_day
    plan_start_date
    plan_end_date
    related_user_list {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    contact_unique_id
    customer_details {
      customer_id
      customer_unique_id
      customer_name
      identity_no
      email
      phone
      fax
      billing_address {
        is_default
        is_same_as_default_address
        address_type
        address_contact_name
        address_contact_phone
        address_contact_fax
        name
        sub_district
        district
        province
        postal_code
        country
      }
    }
    vehicle_type
    item_type
    item_value
    is_frozen
    packing_location
    expected_temperature
    container_type
    pre_discount_amount
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    item_unique_id_list
    item_list {
      id
      item_id
      unique_id
      item_unique_id
      item_name
      item_sku_desc
      item_img_url
      uom_conversion_list
      uom_id
      uom_name
      qty
      price_per_unit
      discount
      vat_percentage
      pre_discount_amount
      vat_amount
      post_discount_amount
      net_amount
      withholding_tax_type
      withholding_tax_value
      total_amount
      stock_qty
    }
    accepted_date
    accepted_remark
    attachment_list {
      attachment_name
      uploaded_date
      url
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
    }
  }
}
    `;
export const useQuotationUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<QuotationUpdateMutation, TError, QuotationUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<QuotationUpdateMutation, TError, QuotationUpdateMutationVariables, TContext>(
      ['QuotationUpdate'],
      (variables?: QuotationUpdateMutationVariables) => fetcher<QuotationUpdateMutation, QuotationUpdateMutationVariables>(client, QuotationUpdateDocument, variables, headers)(),
      options
    );